// Comprehensive translations for all 12 languages
// This file contains all UI text translations

export const translations = {
    en: {
        // Navigation
        dashboard: 'Dashboard',
        checkSymptoms: 'Check Symptoms',
        history: 'History',
        healthLibrary: 'Health Library',
        healthDiary: 'Health Diary',
        consultations: 'Consultations',
        referrals: 'Referrals',
        prescriptions: 'Prescriptions',
        findCare: 'Find Care',
        settings: 'Settings',
        subscription: 'Subscription',
        logout: 'Logout',
        login: 'Log in',
        register: 'Get Started',
        
        // Common actions
        submit: 'Submit',
        cancel: 'Cancel',
        save: 'Save',
        next: 'Next',
        back: 'Back',
        close: 'Close',
        loading: 'Loading...',
        search: 'Search',
        filter: 'Filter',
        delete: 'Delete',
        edit: 'Edit',
        view: 'View',
        download: 'Download',
        share: 'Share',
        copy: 'Copy',
        
        // Symptom check
        selectBodyParts: 'Select affected body parts',
        describeSymptoms: 'Describe your symptoms',
        duration: 'Duration',
        severity: 'Severity',
        medicalHistory: 'Medical History',
        additionalInfo: 'Additional Information',
        startAssessment: 'Start Assessment',
        viewResults: 'View Results',
        newAssessment: 'New Assessment',
        lessThan24Hours: 'Less than 24 hours',
        oneToThreeDays: '1-3 days',
        fourToSevenDays: '4-7 days',
        oneToTwoWeeks: '1-2 weeks',
        moreThanTwoWeeks: 'More than 2 weeks',
        mild: 'Mild',
        moderate: 'Moderate',
        severe: 'Severe',
        emergency: 'Emergency',
        urgent: 'Urgent',
        routine: 'Routine',
        
        // Subscription
        freeTrial: 'Free Trial',
        upgradeNow: 'Upgrade Now',
        viewPlans: 'View Plans',
        checksRemaining: 'checks remaining',
        unlimited: 'Unlimited',
        currentPlan: 'Current Plan',
        chooseYourPlan: 'Choose Your Plan',
        pricesShownIn: 'Prices shown in',
        completePayment: 'Complete Payment',
        choosePaymentMethod: 'Choose your preferred payment method',
        payWithCard: 'Pay with Card',
        securePayment: 'Secure payment powered by Stripe',
        processingPayment: 'Processing payment...',
        pleaseWait: 'Please wait while we securely process your payment. Do not close this window.',
        selected: 'Selected',
        selectPlan: 'Select',
        mostPopular: 'Most Popular',
        payPerUse: 'Pay Per Use',
        basicMonthly: 'Basic Monthly',
        premiumMonthly: 'Premium Monthly',
        perCheck: 'per check',
        perMonth: '/month',
        payOnlyWhenNeeded: 'Pay only when you need it',
        unlimitedForIndividuals: 'Unlimited checks for individuals',
        fullAccessPremium: 'Full access + premium features',
        singleSymptomCheck: 'Single symptom check',
        aiPoweredAssessment: 'AI-powered assessment',
        shareWithDoctor: 'Share with doctor',
        pdfExport: 'PDF export',
        medicalHistoryTracking: 'Medical history tracking',
        photoUploadAnalysis: 'Photo upload analysis',
        everythingInBasic: 'Everything in Basic',
        bookOnlineConsultations: 'Book online consultations*',
        requestPrescriptions: 'Request prescriptions*',
        specialtyReferrals: 'Specialty referrals*',
        prioritySupport: 'Priority support',
        additionalFeesApply: '* Additional fees apply',
        youHaveUnlimitedChecks: 'You have unlimited checks remaining',
        yourFreeTrialEnded: 'Your free trial has ended. Choose a plan to continue.',
        
        // Settings
        language: 'Language',
        selectLanguage: 'Select Language',
        theme: 'Theme',
        darkMode: 'Dark Mode',
        lightMode: 'Light Mode',
        gpDetails: 'GP Details',
        nextOfKin: 'Next of Kin',
        
        // Messages
        welcomeBack: 'Welcome back',
        trialExhausted: 'Free trial exhausted',
        upgradeToContnue: 'Upgrade to continue using MediGuide',
        noResults: 'No results found',
        errorOccurred: 'An error occurred',
        savedSuccessfully: 'Saved successfully',
        shareApp: 'Share App',
        installApp: 'Install App',
        
        // Landing page
        heroTitle: 'AI-Powered Health Assessment',
        heroSubtitle: 'Get instant, personalized health insights powered by advanced AI',
        getStartedFree: 'Get Started Free',
        learnMore: 'Learn More',
        whyChooseUs: 'Why Choose MediGuide',
        howItWorks: 'How It Works',
        features: 'Features',
        aiPowered: 'AI-Powered Analysis',
        aiPoweredDesc: 'Advanced AI analyzes your symptoms for accurate insights',
        available247: 'Available 24/7',
        available247Desc: 'Get health guidance anytime, anywhere',
        securePrivate: 'Secure & Private',
        securePrivateDesc: 'Your health data is encrypted and protected',
        instantResults: 'Instant Results',
        instantResultsDesc: 'Get recommendations in seconds',
        
        // Dashboard
        recentAssessments: 'Recent Assessments',
        quickActions: 'Quick Actions',
        healthOverview: 'Health Overview',
        totalAssessments: 'Total Assessments',
        viewAll: 'View All',
        noAssessments: 'No assessments yet',
        startFirstAssessment: 'Start your first health assessment',
        
        // Login/Register
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        forgotPassword: 'Forgot Password?',
        rememberMe: 'Remember me',
        dontHaveAccount: "Don't have an account?",
        alreadyHaveAccount: 'Already have an account?',
        signUp: 'Sign Up',
        signIn: 'Sign In',
        orContinueWith: 'Or continue with',
        continueWithGoogle: 'Continue with Google',
        createAccount: 'Create Account',
        welcomeTo: 'Welcome to',
        
        // Common UI
        profile: 'Profile',
        account: 'Account',
        ownerPanel: 'Owner Panel',
        name: 'Name',
        phone: 'Phone',
        address: 'Address',
        dateOfBirth: 'Date of Birth',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        other: 'Other',
        
        // Health Library
        categories: 'Categories',
        articles: 'Articles',
        searchArticles: 'Search articles...',
        readMore: 'Read More',
        
        // Diagnosis result
        possibleConditions: 'Possible Conditions',
        recommendations: 'Recommendations',
        immediateAction: 'Immediate Action',
        whenToSeekCare: 'When to Seek Care',
        selfCare: 'Self Care',
        firstAidTips: 'First Aid Tips',
        investigations: 'Investigations',
        treatmentOptions: 'Treatment Options',
        expectedOutcome: 'Expected Outcome',
        disclaimer: 'Disclaimer',
        disclaimerText: 'This assessment is for informational purposes only and does not replace professional medical advice.',
        exportPDF: 'Export PDF',
        shareResults: 'Share Results',
        
        // Footer
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms of Service',
        contact: 'Contact',
        allRightsReserved: 'All rights reserved.',
        medicalDisclaimer: 'MediGuide AI is for informational purposes only and does not replace professional medical advice.',
        
        // Additional Landing Page
        startFreeAssessment: 'Start Free Assessment',
        signIn: 'Sign In',
        privateAndSecure: 'Private & Secure',
        freeToUse: 'Free to Use',
        getBestExperience: 'Get the best experience',
        worksOffline: 'Works offline • Quick access • Free forever',
        addToHome: 'Add to Home',
        joinAsProvider: 'Join as Healthcare Provider',
        earnByProvidingCare: 'Doctors, nurses & healthcare professionals — earn by providing care',
        comprehensiveHealthInsights: 'Comprehensive Health Insights',
        ourAiAnalyzes: 'Our AI analyzes your symptoms to provide detailed health assessments and actionable recommendations.',
        selectBodyArea: 'Select Body Area',
        chooseAffectedParts: 'Choose affected body parts',
        detailWhatExperiencing: 'Detail what you\'re experiencing',
        getAssessment: 'Get Assessment',
        receiveAiAssessment: 'Receive AI-powered assessment',
        tryItNowFree: 'Try It Now — Free',
        threeSimpleSteps: 'Three simple steps to understand your symptoms and get the guidance you need.',
        getMediGuideOnDevice: 'Get MediGuide on Your Device',
        installForInstantAccess: 'Install our app for instant access — works offline, no app store needed!',
        installFreeApp: 'Install Free App',
        addToHomeScreen: 'Add to Home Screen',
        readyToUnderstand: 'Ready to Understand Your Symptoms?',
        joinThousands: 'Join thousands who use MediGuide to make informed health decisions. It\'s free, private, and takes less than 2 minutes.',
        installMediGuide: 'Install MediGuide',
        installForQuickAccess: 'Install MediGuide on your device for quick access, offline support, and a native app experience.',
        forIphone: 'For iPhone/iPad (Safari):',
        tapShareButton: 'Tap the Share button at the bottom of Safari',
        scrollAndTap: 'Scroll down and tap "Add to Home Screen"',
        tapAddConfirm: 'Tap "Add" to confirm',
        forChrome: 'For Chrome / Edge:',
        lookForInstallIcon: 'Look for the install icon in the address bar, or click the menu (⋮) and select "Install app"',
        forFirefox: 'For Firefox:',
        firefoxInstructions: 'Click the menu → More tools → Create shortcut → Check "Open as window"',
        forSafariMac: 'For Safari (Mac):',
        safariMacInstructions: 'Click File → Add to Dock',
        maybeLater: 'Maybe Later',
        copyLink: 'Copy Link',
        quickResults: 'Quick Results',
        underSeconds: 'Under 30 seconds',
        urgencyAssessment: 'Urgency Assessment',
        knowImmediately: 'Know immediately if you need emergency care, urgent attention, or routine care.',
        treatmentGuidance: 'Treatment Guidance',
        getFirstAidTips: 'Get first aid tips, treatment options, and investigation recommendations.',
        instantResultsDesc2: 'Receive comprehensive health insights within seconds, not hours.',
        
        // Register Page
        createAnAccount: 'Create an account',
        getStartedWithFree: 'Get started with your free health assessment',
        continueWithGoogle: 'Continue with Google',
        orRegisterWithEmail: 'Or register with email',
        fullName: 'Full Name',
        passwordMustBe6: 'Password must be at least 6 characters',
        passwordsDoNotMatch: 'Passwords do not match',
        byCreatingAccount: 'By creating an account, you agree that this is an informational tool and not a substitute for professional medical advice.',
        
        // Symptom Check Page
        symptomAssessment: 'Symptom Assessment',
        tellUsAboutSymptoms: 'Tell us about your symptoms to receive an AI-powered health assessment',
        stepOf: 'Step {current} of {total}',
        complete: 'complete',
        body: 'Body',
        symptoms: 'Symptoms',
        details: 'Details',
        upload: 'Upload',
        selectAffectedBodyParts: 'Select Affected Body Parts',
        chooseAllBodyParts: 'Choose all body parts where symptoms are present',
        whoIsThisFor: 'Who is this symptom check for?',
        myself: 'Myself',
        myChild: 'My Child',
        familyMember: 'Family Member',
        someoneElse: 'Someone Else',
        patientAge: 'Patient Age',
        patientSex: 'Patient Sex',
        selected: 'Selected',
        describeYourSymptoms: 'Describe Your Symptoms',
        selectAllSymptoms: 'Select all symptoms you\'re currently experiencing for each body part',
        haveVisibleSymptom: 'Have a visible symptom?',
        uploadPhotoImproves: 'For rashes, swelling, skin discolorations, or injuries - uploading a photo greatly improves diagnosis accuracy.',
        uploadPhotoNow: 'Upload Photo Now',
        photoUploaded: 'Photo uploaded',
        videoUploaded: 'Video uploaded',
        symptomsSelected: '{count} symptom(s) selected',
        durationAndSeverity: 'Duration & Severity',
        helpUsUnderstand: 'Help us understand how long and how severe your symptoms are',
        howLongSymptoms: 'How long have you had these symptoms?',
        selectDuration: 'Select duration',
        selectOne: 'Select one',
        howSevere: 'How severe are your symptoms?',
        mildDesc: 'Noticeable but doesn\'t interfere with daily activities',
        moderateDesc: 'Interferes with some daily activities',
        severeDesc: 'Significantly affects daily life',
        verySevere: 'Very Severe',
        verySevereDesc: 'Unable to perform normal activities',
        preExistingConditions: 'Pre-existing Conditions',
        currentMedications: 'Current Medications',
        knownAllergies: 'Known Allergies',
        previousSurgeries: 'Previous Surgeries',
        clickHere: 'Click here',
        cantFindWhat: 'Can\'t find what you\'re looking for? Add your own:',
        add: 'Add',
        selectedItems: 'Selected items',
        visualEvidenceNotes: 'Visual Evidence & Notes',
        uploadPhotosVideos: 'Upload photos or videos of visible symptoms for more accurate diagnosis (optional)',
        uploadPhotoVideo: 'Upload Photo or Video of Symptoms',
        optional: 'Optional',
        helpfulForDiagnosing: 'Helpful for diagnosing:',
        dragDropOr: 'Drag and drop or',
        browseFiles: 'browse files',
        supportsImages: 'Supports images and videos up to 10MB',
        additionalNotes: 'Additional Notes (Optional)',
        anythingElse: 'Anything else you\'d like to add about your symptoms?',
        generateAssessment: 'Generate Assessment',
        analyzingSymptoms: 'Analyzing your symptoms...',
        importantDisclaimer: 'Important Disclaimer',
        acceptDisclaimer: 'I understand and accept this disclaimer',
        viewMyDiagnosis: 'View My Diagnosis',
        pleaseAcceptDisclaimer: 'Please accept the disclaimer to continue',
        freeTrialExhausted: 'Free Trial Exhausted',
        youveUsedAllFree: 'You\'ve used all your free symptom checks.',
        upgradeForUnlimited: 'Upgrade to a premium plan for unlimited assessments and advanced features.',
        
        // Settings Page
        backToDashboard: 'Back to Dashboard',
        manageProfile: 'Manage your profile and account settings',
        profileInformation: 'Profile Information',
        updatePersonalDetails: 'Update your personal details and profile picture',
        changePhoto: 'Change Photo',
        jpgPngGif: 'JPG, PNG or GIF. Max 5MB',
        phoneNumber: 'Phone Number',
        gpDoctorDetails: 'GP / Doctor Details',
        primaryCarePhysician: 'Your primary care physician information for medical records and referrals',
        doctorName: 'Doctor\'s Name',
        practiceSurgeryName: 'Practice/Surgery Name',
        practiceAddress: 'Practice Address',
        nextOfKinEmergency: 'Next of Kin / Emergency Contact',
        emergencyContactInfo: 'Emergency contact information for medical situations',
        relationship: 'Relationship',
        noteEmergencyOnly: 'This information will only be used in case of medical emergency and will be shared with healthcare providers when necessary.',
        languageSettings: 'Language Settings',
        selectPreferredLanguage: 'Select your preferred language for the interface',
        currentLanguage: 'Current language',
        someMedicalContent: 'Some medical content may still appear in English for accuracy.',
        accountSecurity: 'Account Security',
        manageAccountSecurity: 'Manage your account security settings',
        changePassword: 'Change Password',
        verified: 'Verified',
        dangerZone: 'Danger Zone',
        irreversibleActions: 'Irreversible account actions',
        deactivateAccount: 'Deactivate Account',
        permanentlyDelete: 'Permanently delete your account and all associated data. This action cannot be undone.',
        deactivate: 'Deactivate',
        typeDeactivate: 'Type "deactivate" to confirm',
        profileInfo: 'Profile information',
        symptomCheckHistory: 'Symptom check history',
        diagnosisRecords: 'Diagnosis records',
        subscriptionDetails: 'Subscription details',
        willBePermanentlyDeleted: 'will be permanently deleted.',
        saving: 'Saving...',
        saveChanges: 'Save Changes',
        deactivating: 'Deactivating...',
        
        // Health Library
        patientInfoLeaflets: 'Patient information leaflets and health resources',
        searchConditions: 'Search conditions, procedures...',
        conditions: 'Conditions',
        procedures: 'Procedures',
        resources: 'Resources',
        overview: 'Overview',
        causesRiskFactors: 'Causes & Risk Factors',
        treatment: 'Treatment',
        prevention: 'Prevention',
        whenToSeekMedicalHelp: 'When to Seek Medical Help',
        preparation: 'Preparation',
        theProcedure: 'The Procedure',
        aftercare: 'Aftercare',
        results: 'Results',
        forGeneralGuidance: 'This information is for general guidance only. Always consult your healthcare provider for personalized medical advice.',
        noConditionsFound: 'No conditions found matching your search.',
        noProceduresFound: 'No procedures found matching your search.',
        
        // Health Diary
        trackHealthPatterns: 'Track your health patterns and set medication reminders',
        addEntry: 'Add Entry',
        setReminder: 'Set Reminder',
        menstrualCycle: 'Menstrual Cycle',
        painDiary: 'Pain Diary',
        medication: 'Medication',
        recordHealthData: 'Record your health data for tracking',
        selectDate: 'Select Date',
        flowLevel: 'Flow Level',
        selectFlowLevel: 'Select flow level',
        mood: 'Mood',
        howAreYouFeeling: 'How are you feeling today?',
        notes: 'Notes',
        anyAdditionalNotes: 'Any additional notes...',
        painLevel: 'Pain Level (1-10)',
        selectPainLevel: 'Select pain level',
        location: 'Location',
        description: 'Description',
        triggers: 'Triggers',
        whatTriggered: 'What triggered the pain?',
        reliefMeasures: 'Relief Measures',
        whatHelpedRelieve: 'What helped relieve the pain?',
        medicationName: 'Medication Name',
        enterMedicationName: 'Enter medication name',
        dosage: 'Dosage',
        frequency: 'Frequency',
        selectFrequency: 'Select frequency',
        timeTaken: 'Time Taken',
        sideEffects: 'Side Effects',
        anySideEffects: 'Any side effects experienced?',
        saveEntry: 'Save Entry',
        createReminder: 'Create Reminder',
        reminderType: 'Reminder Type',
        title: 'Title',
        time: 'Time',
        repeatDays: 'Repeat Days',
        activeReminders: 'Active Reminders',
        daily: 'Daily',
        entries: 'Entries',
        noEntriesYet: 'No entries yet',
        addYourFirstEntry: 'Add Your First Entry',
        flow: 'Flow',
        type: 'Type',
        takenAt: 'Taken at',
        
        // Profile Page
        yourProfile: 'Your Profile',
        managePersonalInfo: 'Manage your personal information and emergency contacts',
        personal: 'Personal',
        personalInformation: 'Personal Information',
        updateProfilePicture: 'Update your profile picture and name',
        emergencyContactInformation: 'Emergency contact information',
        
        // History Page
        assessmentHistory: 'Assessment History',
        viewAndManage: 'View and manage your past symptom assessments',
        allAssessments: 'All Assessments',
        totalAssessment: 'total assessment',
        totalAssessments2: 'total assessments',
        newCheck: 'New Check',
        noAssessmentsYet: 'No assessments yet',
        startFirstSymptomCheck: 'Start your first symptom check to see your history here',
        startFirstAssessment2: 'Start First Assessment',
        daysAgo: 'days ago',
        today: 'Today',
        yesterday: 'Yesterday',
        deleteAssessment: 'Delete Assessment',
        areYouSureDelete: 'Are you sure you want to delete this assessment? This action cannot be undone.',
        deleting: 'Deleting...',
        
        // Diagnosis Result Page
        yourHealthAssessment: 'Your Health Assessment',
        imageAnalyzed: 'Image Analyzed',
        downloadPDF: 'Download PDF',
        shareWithDoctor: 'Share with Doctor',
        generating: 'Generating...',
        seekImmediateMedical: 'Seek immediate medical attention',
        seeDoctor24to48: 'See a doctor within 24-48 hours',
        canWaitScheduled: 'Can wait for a scheduled appointment',
        callEmergencyServices: 'Call Emergency Services',
        reportedSymptoms: 'Reported Symptoms',
        bodyParts: 'Body Parts',
        medicalHistoryConsidered: 'Medical History Considered:',
        conditionsCount: '{count} conditions',
        medicationsCount: '{count} medications',
        allergiesCount: '{count} allergies',
        possibleConditions2: 'Possible Conditions',
        basedOnSymptoms: 'Based on your symptoms, these conditions may be relevant',
        highLikelihood: 'High likelihood',
        mediumLikelihood: 'Medium likelihood',
        lowLikelihood: 'Low likelihood',
        advice: 'Advice',
        tests: 'Tests',
        recommendedInvestigations: 'Recommended Investigations',
        testsThatMayHelp: 'Tests that may help diagnose your condition',
        relatedHealthInformation: 'Related Health Information',
        learnMoreAbout: 'Learn more about conditions that may be relevant to your symptoms',
        viewPatientInformation: 'View patient information',
        browseHealthLibrary: 'Browse Health Library',
        startNewCheck: 'Start New Check',
        shareWithYourDoctor: 'Share with Your Doctor',
        sendLinkToProvider: 'Send this link to your healthcare provider. The link is valid for 7 days.',
        linkCopied: 'Link copied to clipboard!',
        shareViaEmail: 'Share via Email',
        previewSharedPage: 'Preview Shared Page',
        doctorCanView: 'Your doctor can view this without creating an account',
        errorLoadingDiagnosis: 'Error Loading Diagnosis',
        returnToDashboard: 'Return to Dashboard',
        loadingDiagnosis: 'Loading diagnosis...',
        
        // Dashboard specific
        trackHealthAssessments: 'Track your health assessments and get AI-powered insights.',
        newSymptomCheck: 'New Symptom Check',
        getAiPoweredAssessment: 'Get an AI-powered health assessment',
        totalChecks: 'Total Checks',
        latestSymptomChecks: 'Your latest symptom checks',
        startYourFirstCheck: 'Start Your First Check',
    },
    
    fr: {
        dashboard: 'Tableau de bord',
        checkSymptoms: 'Vérifier les symptômes',
        history: 'Historique',
        healthLibrary: 'Bibliothèque santé',
        healthDiary: 'Journal de santé',
        consultations: 'Consultations',
        referrals: 'Références',
        prescriptions: 'Ordonnances',
        findCare: 'Trouver des soins',
        settings: 'Paramètres',
        subscription: 'Abonnement',
        logout: 'Déconnexion',
        login: 'Connexion',
        register: 'Commencer',
        submit: 'Soumettre',
        cancel: 'Annuler',
        save: 'Enregistrer',
        next: 'Suivant',
        back: 'Retour',
        close: 'Fermer',
        loading: 'Chargement...',
        search: 'Rechercher',
        filter: 'Filtrer',
        delete: 'Supprimer',
        edit: 'Modifier',
        view: 'Voir',
        download: 'Télécharger',
        share: 'Partager',
        copy: 'Copier',
        selectBodyParts: 'Sélectionnez les parties du corps affectées',
        describeSymptoms: 'Décrivez vos symptômes',
        duration: 'Durée',
        severity: 'Gravité',
        medicalHistory: 'Antécédents médicaux',
        additionalInfo: 'Informations supplémentaires',
        startAssessment: 'Commencer l\'évaluation',
        viewResults: 'Voir les résultats',
        newAssessment: 'Nouvelle évaluation',
        lessThan24Hours: 'Moins de 24 heures',
        oneToThreeDays: '1-3 jours',
        fourToSevenDays: '4-7 jours',
        oneToTwoWeeks: '1-2 semaines',
        moreThanTwoWeeks: 'Plus de 2 semaines',
        mild: 'Léger',
        moderate: 'Modéré',
        severe: 'Sévère',
        emergency: 'Urgence',
        urgent: 'Urgent',
        routine: 'Routine',
        freeTrial: 'Essai gratuit',
        upgradeNow: 'Mettre à niveau',
        viewPlans: 'Voir les plans',
        checksRemaining: 'vérifications restantes',
        unlimited: 'Illimité',
        currentPlan: 'Plan actuel',
        chooseYourPlan: 'Choisissez votre forfait',
        pricesShownIn: 'Prix affichés en',
        completePayment: 'Terminer le paiement',
        choosePaymentMethod: 'Choisissez votre méthode de paiement',
        payWithCard: 'Payer par carte',
        securePayment: 'Paiement sécurisé par Stripe',
        processingPayment: 'Traitement du paiement...',
        pleaseWait: 'Veuillez patienter. Ne fermez pas cette fenêtre.',
        selected: 'Sélectionné',
        selectPlan: 'Sélectionner',
        mostPopular: 'Le plus populaire',
        payPerUse: 'Paiement à l\'utilisation',
        basicMonthly: 'Basic mensuel',
        premiumMonthly: 'Premium mensuel',
        perCheck: 'par vérification',
        perMonth: '/mois',
        payOnlyWhenNeeded: 'Payez quand vous en avez besoin',
        unlimitedForIndividuals: 'Vérifications illimitées',
        fullAccessPremium: 'Accès complet + premium',
        singleSymptomCheck: 'Vérification unique',
        aiPoweredAssessment: 'Évaluation par IA',
        shareWithDoctor: 'Partager avec médecin',
        pdfExport: 'Export PDF',
        medicalHistoryTracking: 'Suivi antécédents',
        photoUploadAnalysis: 'Analyse photos',
        everythingInBasic: 'Tout dans Basic',
        bookOnlineConsultations: 'Consultations en ligne*',
        requestPrescriptions: 'Demander ordonnances*',
        specialtyReferrals: 'Références spécialistes*',
        prioritySupport: 'Support prioritaire',
        additionalFeesApply: '* Frais supplémentaires',
        youHaveUnlimitedChecks: 'Vérifications illimitées',
        yourFreeTrialEnded: 'Essai terminé. Choisissez un forfait.',
        language: 'Langue',
        selectLanguage: 'Sélectionner la langue',
        theme: 'Thème',
        darkMode: 'Mode sombre',
        lightMode: 'Mode clair',
        gpDetails: 'Détails du médecin',
        nextOfKin: 'Personne à contacter',
        welcomeBack: 'Bon retour',
        trialExhausted: 'Essai gratuit épuisé',
        upgradeToContnue: 'Passez à la version supérieure pour continuer',
        noResults: 'Aucun résultat trouvé',
        errorOccurred: 'Une erreur est survenue',
        savedSuccessfully: 'Enregistré avec succès',
        shareApp: 'Partager l\'application',
        installApp: 'Installer l\'application',
        heroTitle: 'Évaluation de santé par IA',
        heroSubtitle: 'Obtenez des informations de santé personnalisées instantanées',
        getStartedFree: 'Commencer gratuitement',
        learnMore: 'En savoir plus',
        whyChooseUs: 'Pourquoi choisir MediGuide',
        howItWorks: 'Comment ça marche',
        features: 'Fonctionnalités',
        aiPowered: 'Analyse par IA',
        aiPoweredDesc: 'L\'IA analyse vos symptômes pour des informations précises',
        available247: 'Disponible 24h/24',
        available247Desc: 'Obtenez des conseils de santé à tout moment',
        securePrivate: 'Sécurisé et privé',
        securePrivateDesc: 'Vos données de santé sont cryptées et protégées',
        instantResults: 'Résultats instantanés',
        instantResultsDesc: 'Obtenez des recommandations en secondes',
        recentAssessments: 'Évaluations récentes',
        quickActions: 'Actions rapides',
        healthOverview: 'Aperçu de santé',
        totalAssessments: 'Total des évaluations',
        viewAll: 'Voir tout',
        noAssessments: 'Aucune évaluation',
        startFirstAssessment: 'Commencez votre première évaluation',
        email: 'Email',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        forgotPassword: 'Mot de passe oublié?',
        rememberMe: 'Se souvenir de moi',
        dontHaveAccount: 'Vous n\'avez pas de compte?',
        alreadyHaveAccount: 'Vous avez déjà un compte?',
        signUp: 'S\'inscrire',
        signIn: 'Se connecter',
        orContinueWith: 'Ou continuer avec',
        continueWithGoogle: 'Continuer avec Google',
        createAccount: 'Créer un compte',
        welcomeTo: 'Bienvenue sur',
        profile: 'Profil',
        account: 'Compte',
        ownerPanel: 'Panneau propriétaire',
        name: 'Nom',
        phone: 'Téléphone',
        address: 'Adresse',
        dateOfBirth: 'Date de naissance',
        gender: 'Genre',
        male: 'Homme',
        female: 'Femme',
        other: 'Autre',
        categories: 'Catégories',
        articles: 'Articles',
        searchArticles: 'Rechercher des articles...',
        readMore: 'Lire la suite',
        possibleConditions: 'Conditions possibles',
        recommendations: 'Recommandations',
        immediateAction: 'Action immédiate',
        whenToSeekCare: 'Quand consulter',
        selfCare: 'Auto-soins',
        firstAidTips: 'Conseils de premiers secours',
        investigations: 'Examens',
        treatmentOptions: 'Options de traitement',
        expectedOutcome: 'Résultat attendu',
        disclaimer: 'Avertissement',
        disclaimerText: 'Cette évaluation est uniquement informative et ne remplace pas un avis médical professionnel.',
        exportPDF: 'Exporter en PDF',
        shareResults: 'Partager les résultats',
        getBestExperience: 'Obtenez la meilleure expérience',
        worksOffline: 'Fonctionne hors ligne • Accès rapide • Gratuit pour toujours',
        joinAsProvider: 'Rejoignez en tant que prestataire de soins',
        quickResults: 'Résultats rapides',
        underSeconds: 'Moins de 30 secondes',
        backToDashboard: 'Retour au tableau de bord',
        backToLibrary: 'Retour à la bibliothèque',
        profileInformation: 'Informations du profil',
        updatePersonalDetails: 'Mettez à jour vos informations personnelles',
        changePhoto: 'Changer la photo',
        jpgPngGif: 'JPG, PNG ou GIF. Max 5Mo',
        fullName: 'Nom complet',
        phoneNumber: 'Numéro de téléphone',
        gpDoctorDetails: 'Détails du médecin généraliste',
        primaryCarePhysician: 'Informations de votre médecin traitant',
        doctorName: 'Nom du médecin',
        practiceAddress: 'Adresse du cabinet',
        emergencyContactInfo: 'Informations de contact d\'urgence',
        relationship: 'Relation',
        saveChanges: 'Enregistrer les modifications',
        manageProfile: 'Gérez votre profil et vos paramètres',
        assessmentHistory: 'Historique des évaluations',
        viewAndManage: 'Consultez et gérez vos évaluations passées',
        allAssessments: 'Toutes les évaluations',
        newCheck: 'Nouvelle vérification',
        noAssessmentsYet: 'Aucune évaluation pour le moment',
        startFirstSymptomCheck: 'Commencez votre première vérification de symptômes',
        today: 'Aujourd\'hui',
        yesterday: 'Hier',
        daysAgo: 'jours passés',
        deleteAssessment: 'Supprimer l\'évaluation',
        areYouSureDelete: 'Êtes-vous sûr de vouloir supprimer cette évaluation? Cette action est irréversible.',
        yourProfile: 'Votre profil',
        managePersonalInfo: 'Gérez vos informations personnelles',
        personal: 'Personnel',
        yourHealthAssessment: 'Votre évaluation de santé',
        imageAnalyzed: 'Image analysée',
        downloadPDF: 'Télécharger le PDF',
        shareWithDoctor: 'Partager avec le médecin',
        generating: 'Génération...',
        callEmergencyServices: 'Appeler les services d\'urgence',
        reportedSymptoms: 'Symptômes signalés',
        bodyParts: 'Parties du corps',
        loadingDiagnosis: 'Chargement du diagnostic...',
        errorLoadingDiagnosis: 'Erreur de chargement du diagnostic',
        returnToDashboard: 'Retour au tableau de bord',
        trackHealthPatterns: 'Suivez vos habitudes de santé et définissez des rappels',
        addEntry: 'Ajouter une entrée',
        setReminder: 'Définir un rappel',
        patientInfoLeaflets: 'Fiches d\'information patient et ressources santé',
        searchConditions: 'Rechercher des conditions, procédures...',
        conditions: 'Conditions',
        procedures: 'Procédures',
        resources: 'Ressources',
        overview: 'Aperçu',
        causesRiskFactors: 'Causes et facteurs de risque',
        prevention: 'Prévention',
        whenToSeekMedicalHelp: 'Quand consulter un médecin',
        preparation: 'Préparation',
        theProcedure: 'La procédure',
        aftercare: 'Soins post-opératoires',
        results: 'Résultats',
        forGeneralGuidance: 'Ces informations sont données à titre indicatif uniquement. Consultez toujours votre médecin pour des conseils médicaux personnalisés.',
        trackHealthAssessments: 'Suivez vos évaluations de santé et obtenez des informations alimentées par l\'IA.',
        newSymptomCheck: 'Nouvelle vérification des symptômes',
        getAiPoweredAssessment: 'Obtenez une évaluation de santé alimentée par l\'IA',
        totalChecks: 'Total des vérifications',
        latestSymptomChecks: 'Vos dernières vérifications de symptômes',
        startYourFirstCheck: 'Commencez votre première vérification',
        languageSettings: 'Paramètres de langue',
        selectPreferredLanguage: 'Sélectionnez votre langue préférée pour l\'interface',
        currentLanguage: 'Langue actuelle',
        someMedicalContent: 'Certains contenus médicaux peuvent encore apparaître en anglais pour plus de précision.',
    },
    
    ar: {
        dashboard: 'لوحة التحكم',
        checkSymptoms: 'فحص الأعراض',
        history: 'السجل',
        healthLibrary: 'مكتبة الصحة',
        healthDiary: 'يوميات الصحة',
        consultations: 'الاستشارات',
        referrals: 'الإحالات',
        prescriptions: 'الوصفات الطبية',
        findCare: 'البحث عن رعاية',
        settings: 'الإعدادات',
        subscription: 'الاشتراك',
        logout: 'تسجيل الخروج',
        login: 'تسجيل الدخول',
        register: 'ابدأ',
        submit: 'إرسال',
        cancel: 'إلغاء',
        save: 'حفظ',
        next: 'التالي',
        back: 'رجوع',
        close: 'إغلاق',
        loading: 'جاري التحميل...',
        search: 'بحث',
        filter: 'تصفية',
        delete: 'حذف',
        edit: 'تعديل',
        view: 'عرض',
        download: 'تحميل',
        share: 'مشاركة',
        copy: 'نسخ',
        selectBodyParts: 'حدد أجزاء الجسم المصابة',
        describeSymptoms: 'صف أعراضك',
        duration: 'المدة',
        severity: 'الشدة',
        medicalHistory: 'التاريخ الطبي',
        additionalInfo: 'معلومات إضافية',
        startAssessment: 'بدء التقييم',
        viewResults: 'عرض النتائج',
        newAssessment: 'تقييم جديد',
        lessThan24Hours: 'أقل من 24 ساعة',
        oneToThreeDays: '1-3 أيام',
        fourToSevenDays: '4-7 أيام',
        oneToTwoWeeks: '1-2 أسابيع',
        moreThanTwoWeeks: 'أكثر من أسبوعين',
        mild: 'خفيف',
        moderate: 'متوسط',
        severe: 'شديد',
        emergency: 'طوارئ',
        urgent: 'عاجل',
        routine: 'روتيني',
        freeTrial: 'تجربة مجانية',
        upgradeNow: 'الترقية الآن',
        viewPlans: 'عرض الخطط',
        checksRemaining: 'فحوصات متبقية',
        unlimited: 'غير محدود',
        currentPlan: 'الخطة الحالية',
        chooseYourPlan: 'اختر خطتك',
        pricesShownIn: 'الأسعار معروضة بـ',
        completePayment: 'إتمام الدفع',
        choosePaymentMethod: 'اختر طريقة الدفع المفضلة',
        payWithCard: 'الدفع بالبطاقة',
        securePayment: 'دفع آمن عبر Stripe',
        processingPayment: 'جاري معالجة الدفع...',
        pleaseWait: 'يرجى الانتظار. لا تغلق هذه النافذة.',
        selected: 'محدد',
        selectPlan: 'اختيار',
        mostPopular: 'الأكثر شعبية',
        payPerUse: 'الدفع عند الاستخدام',
        basicMonthly: 'الأساسي الشهري',
        premiumMonthly: 'المميز الشهري',
        perCheck: 'لكل فحص',
        perMonth: '/شهر',
        payOnlyWhenNeeded: 'ادفع فقط عند الحاجة',
        unlimitedForIndividuals: 'فحوصات غير محدودة',
        fullAccessPremium: 'وصول كامل + مميزات',
        singleSymptomCheck: 'فحص واحد للأعراض',
        aiPoweredAssessment: 'تقييم بالذكاء الاصطناعي',
        shareWithDoctor: 'مشاركة مع الطبيب',
        pdfExport: 'تصدير PDF',
        medicalHistoryTracking: 'تتبع السجل الطبي',
        photoUploadAnalysis: 'تحليل الصور',
        everythingInBasic: 'كل ما في الأساسي',
        bookOnlineConsultations: 'حجز استشارات*',
        requestPrescriptions: 'طلب وصفات*',
        specialtyReferrals: 'إحالات متخصصة*',
        prioritySupport: 'دعم أولوي',
        additionalFeesApply: '* رسوم إضافية',
        youHaveUnlimitedChecks: 'لديك فحوصات غير محدودة',
        yourFreeTrialEnded: 'انتهت التجربة. اختر خطة للمتابعة.',
        language: 'اللغة',
        selectLanguage: 'اختر اللغة',
        theme: 'المظهر',
        darkMode: 'الوضع الداكن',
        lightMode: 'الوضع الفاتح',
        gpDetails: 'تفاصيل الطبيب',
        nextOfKin: 'أقرب الأقارب',
        welcomeBack: 'مرحباً بعودتك',
        trialExhausted: 'انتهت التجربة المجانية',
        upgradeToContnue: 'قم بالترقية للمتابعة',
        noResults: 'لم يتم العثور على نتائج',
        errorOccurred: 'حدث خطأ',
        savedSuccessfully: 'تم الحفظ بنجاح',
        shareApp: 'مشاركة التطبيق',
        installApp: 'تثبيت التطبيق',
        heroTitle: 'تقييم صحي بالذكاء الاصطناعي',
        heroSubtitle: 'احصل على رؤى صحية فورية ومخصصة',
        getStartedFree: 'ابدأ مجاناً',
        learnMore: 'اعرف المزيد',
        whyChooseUs: 'لماذا تختار MediGuide',
        howItWorks: 'كيف يعمل',
        features: 'المميزات',
        aiPowered: 'تحليل بالذكاء الاصطناعي',
        aiPoweredDesc: 'الذكاء الاصطناعي يحلل أعراضك للحصول على رؤى دقيقة',
        available247: 'متاح على مدار الساعة',
        available247Desc: 'احصل على إرشادات صحية في أي وقت',
        securePrivate: 'آمن وخاص',
        securePrivateDesc: 'بياناتك الصحية مشفرة ومحمية',
        instantResults: 'نتائج فورية',
        instantResultsDesc: 'احصل على توصيات في ثوانٍ',
        recentAssessments: 'التقييمات الأخيرة',
        quickActions: 'إجراءات سريعة',
        healthOverview: 'نظرة عامة على الصحة',
        totalAssessments: 'إجمالي التقييمات',
        viewAll: 'عرض الكل',
        noAssessments: 'لا توجد تقييمات',
        startFirstAssessment: 'ابدأ تقييمك الصحي الأول',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        confirmPassword: 'تأكيد كلمة المرور',
        forgotPassword: 'نسيت كلمة المرور؟',
        rememberMe: 'تذكرني',
        dontHaveAccount: 'ليس لديك حساب؟',
        alreadyHaveAccount: 'لديك حساب بالفعل؟',
        signUp: 'إنشاء حساب',
        signIn: 'تسجيل الدخول',
        orContinueWith: 'أو تابع مع',
        continueWithGoogle: 'المتابعة مع Google',
        createAccount: 'إنشاء حساب',
        welcomeTo: 'مرحباً بك في',
        profile: 'الملف الشخصي',
        account: 'الحساب',
        ownerPanel: 'لوحة المالك',
        name: 'الاسم',
        phone: 'الهاتف',
        address: 'العنوان',
        dateOfBirth: 'تاريخ الميلاد',
        gender: 'الجنس',
        male: 'ذكر',
        female: 'أنثى',
        other: 'آخر',
        categories: 'الفئات',
        articles: 'المقالات',
        searchArticles: 'البحث في المقالات...',
        readMore: 'قراءة المزيد',
        possibleConditions: 'الحالات المحتملة',
        recommendations: 'التوصيات',
        immediateAction: 'إجراء فوري',
        whenToSeekCare: 'متى تطلب الرعاية',
        selfCare: 'الرعاية الذاتية',
        firstAidTips: 'نصائح الإسعافات الأولية',
        investigations: 'الفحوصات',
        treatmentOptions: 'خيارات العلاج',
        expectedOutcome: 'النتيجة المتوقعة',
        disclaimer: 'إخلاء المسؤولية',
        disclaimerText: 'هذا التقييم لأغراض إعلامية فقط ولا يحل محل المشورة الطبية المهنية.',
        exportPDF: 'تصدير PDF',
        shareResults: 'مشاركة النتائج',
        getBestExperience: 'احصل على أفضل تجربة',
        worksOffline: 'يعمل بدون اتصال • وصول سريع • مجاني للأبد',
        joinAsProvider: 'انضم كمقدم رعاية صحية',
        quickResults: 'نتائج سريعة',
        underSeconds: 'أقل من 30 ثانية',
        backToDashboard: 'العودة إلى لوحة التحكم',
        backToLibrary: 'العودة إلى المكتبة',
        profileInformation: 'معلومات الملف الشخصي',
        updatePersonalDetails: 'تحديث بياناتك الشخصية',
        changePhoto: 'تغيير الصورة',
        jpgPngGif: 'JPG أو PNG أو GIF. الحد الأقصى 5 ميجابايت',
        fullName: 'الاسم الكامل',
        phoneNumber: 'رقم الهاتف',
        gpDoctorDetails: 'تفاصيل الطبيب',
        primaryCarePhysician: 'معلومات طبيبك الأساسي',
        doctorName: 'اسم الطبيب',
        practiceAddress: 'عنوان العيادة',
        emergencyContactInfo: 'معلومات الاتصال في حالات الطوارئ',
        relationship: 'العلاقة',
        saveChanges: 'حفظ التغييرات',
        manageProfile: 'إدارة ملفك الشخصي وإعداداتك',
        assessmentHistory: 'سجل التقييمات',
        viewAndManage: 'عرض وإدارة تقييماتك السابقة',
        allAssessments: 'جميع التقييمات',
        newCheck: 'فحص جديد',
        noAssessmentsYet: 'لا توجد تقييمات بعد',
        startFirstSymptomCheck: 'ابدأ فحص الأعراض الأول',
        today: 'اليوم',
        yesterday: 'أمس',
        daysAgo: 'أيام مضت',
        deleteAssessment: 'حذف التقييم',
        areYouSureDelete: 'هل أنت متأكد من حذف هذا التقييم؟ لا يمكن التراجع عن هذا الإجراء.',
        yourProfile: 'ملفك الشخصي',
        managePersonalInfo: 'إدارة معلوماتك الشخصية',
        personal: 'شخصي',
        yourHealthAssessment: 'تقييمك الصحي',
        imageAnalyzed: 'تم تحليل الصورة',
        downloadPDF: 'تحميل PDF',
        shareWithDoctor: 'مشاركة مع الطبيب',
        generating: 'جاري الإنشاء...',
        callEmergencyServices: 'اتصل بخدمات الطوارئ',
        reportedSymptoms: 'الأعراض المُبلغ عنها',
        bodyParts: 'أجزاء الجسم',
        loadingDiagnosis: 'جاري تحميل التشخيص...',
        errorLoadingDiagnosis: 'خطأ في تحميل التشخيص',
        returnToDashboard: 'العودة إلى لوحة التحكم',
        trackHealthPatterns: 'تتبع أنماط صحتك وضبط التذكيرات',
        addEntry: 'إضافة إدخال',
        setReminder: 'ضبط تذكير',
        patientInfoLeaflets: 'نشرات معلومات المريض والموارد الصحية',
        searchConditions: 'البحث عن الحالات والإجراءات...',
        conditions: 'الحالات',
        procedures: 'الإجراءات',
        resources: 'الموارد',
        overview: 'نظرة عامة',
        causesRiskFactors: 'الأسباب وعوامل الخطر',
        prevention: 'الوقاية',
        whenToSeekMedicalHelp: 'متى تطلب المساعدة الطبية',
        preparation: 'التحضير',
        theProcedure: 'الإجراء',
        aftercare: 'الرعاية اللاحقة',
        results: 'النتائج',
        forGeneralGuidance: 'هذه المعلومات للإرشاد العام فقط. استشر طبيبك دائمًا للحصول على مشورة طبية مخصصة.',
        trackHealthAssessments: 'تتبع تقييماتك الصحية واحصل على رؤى مدعومة بالذكاء الاصطناعي.',
        newSymptomCheck: 'فحص أعراض جديد',
        getAiPoweredAssessment: 'احصل على تقييم صحي مدعوم بالذكاء الاصطناعي',
        totalChecks: 'إجمالي الفحوصات',
        latestSymptomChecks: 'أحدث فحوصات الأعراض',
        startYourFirstCheck: 'ابدأ فحصك الأول',
        languageSettings: 'إعدادات اللغة',
        selectPreferredLanguage: 'اختر لغتك المفضلة للواجهة',
        currentLanguage: 'اللغة الحالية',
        someMedicalContent: 'قد يظهر بعض المحتوى الطبي باللغة الإنجليزية لضمان الدقة.',
    },
    
    ru: {
        dashboard: 'Панель управления',
        checkSymptoms: 'Проверить симптомы',
        history: 'История',
        healthLibrary: 'Библиотека здоровья',
        healthDiary: 'Дневник здоровья',
        consultations: 'Консультации',
        referrals: 'Направления',
        prescriptions: 'Рецепты',
        findCare: 'Найти помощь',
        settings: 'Настройки',
        subscription: 'Подписка',
        logout: 'Выйти',
        login: 'Войти',
        register: 'Начать',
        submit: 'Отправить',
        cancel: 'Отмена',
        save: 'Сохранить',
        next: 'Далее',
        back: 'Назад',
        close: 'Закрыть',
        loading: 'Загрузка...',
        search: 'Поиск',
        filter: 'Фильтр',
        delete: 'Удалить',
        edit: 'Редактировать',
        view: 'Просмотр',
        download: 'Скачать',
        share: 'Поделиться',
        copy: 'Копировать',
        selectBodyParts: 'Выберите пораженные части тела',
        describeSymptoms: 'Опишите ваши симптомы',
        duration: 'Продолжительность',
        severity: 'Тяжесть',
        medicalHistory: 'История болезни',
        additionalInfo: 'Дополнительная информация',
        startAssessment: 'Начать оценку',
        viewResults: 'Посмотреть результаты',
        newAssessment: 'Новая оценка',
        lessThan24Hours: 'Менее 24 часов',
        oneToThreeDays: '1-3 дня',
        fourToSevenDays: '4-7 дней',
        oneToTwoWeeks: '1-2 недели',
        moreThanTwoWeeks: 'Более 2 недель',
        mild: 'Легкая',
        moderate: 'Умеренная',
        severe: 'Тяжелая',
        emergency: 'Экстренно',
        urgent: 'Срочно',
        routine: 'Плановый',
        freeTrial: 'Бесплатная пробная версия',
        upgradeNow: 'Обновить сейчас',
        viewPlans: 'Посмотреть планы',
        checksRemaining: 'проверок осталось',
        unlimited: 'Неограниченно',
        currentPlan: 'Текущий план',
        chooseYourPlan: 'Выберите план',
        pricesShownIn: 'Цены указаны в',
        completePayment: 'Завершить оплату',
        choosePaymentMethod: 'Выберите способ оплаты',
        payWithCard: 'Оплата картой',
        securePayment: 'Безопасная оплата через Stripe',
        processingPayment: 'Обработка платежа...',
        pleaseWait: 'Пожалуйста, подождите. Не закрывайте окно.',
        selected: 'Выбрано',
        selectPlan: 'Выбрать',
        mostPopular: 'Самый популярный',
        payPerUse: 'Оплата за использование',
        basicMonthly: 'Базовый месячный',
        premiumMonthly: 'Премиум месячный',
        perCheck: 'за проверку',
        perMonth: '/месяц',
        payOnlyWhenNeeded: 'Платите только при необходимости',
        unlimitedForIndividuals: 'Неограниченные проверки',
        fullAccessPremium: 'Полный доступ + премиум',
        singleSymptomCheck: 'Одна проверка симптомов',
        aiPoweredAssessment: 'Оценка с помощью ИИ',
        shareWithDoctor: 'Поделиться с врачом',
        pdfExport: 'Экспорт PDF',
        medicalHistoryTracking: 'Отслеживание истории',
        photoUploadAnalysis: 'Анализ фото',
        everythingInBasic: 'Всё из Базового',
        bookOnlineConsultations: 'Онлайн консультации*',
        requestPrescriptions: 'Запрос рецептов*',
        specialtyReferrals: 'Направления к специалистам*',
        prioritySupport: 'Приоритетная поддержка',
        additionalFeesApply: '* Дополнительная плата',
        youHaveUnlimitedChecks: 'У вас неограниченные проверки',
        yourFreeTrialEnded: 'Пробный период закончился. Выберите план.',
        language: 'Язык',
        selectLanguage: 'Выберите язык',
        theme: 'Тема',
        darkMode: 'Темный режим',
        lightMode: 'Светлый режим',
        gpDetails: 'Данные врача',
        nextOfKin: 'Ближайший родственник',
        welcomeBack: 'С возвращением',
        trialExhausted: 'Пробная версия исчерпана',
        upgradeToContnue: 'Обновите для продолжения',
        noResults: 'Результаты не найдены',
        errorOccurred: 'Произошла ошибка',
        savedSuccessfully: 'Успешно сохранено',
        shareApp: 'Поделиться приложением',
        installApp: 'Установить приложение',
        heroTitle: 'Оценка здоровья с помощью ИИ',
        heroSubtitle: 'Получите мгновенные персонализированные рекомендации',
        getStartedFree: 'Начать бесплатно',
        learnMore: 'Узнать больше',
        whyChooseUs: 'Почему MediGuide',
        howItWorks: 'Как это работает',
        features: 'Функции',
        aiPowered: 'Анализ на основе ИИ',
        aiPoweredDesc: 'ИИ анализирует ваши симптомы для точных выводов',
        available247: 'Доступно 24/7',
        available247Desc: 'Получайте рекомендации в любое время',
        securePrivate: 'Безопасно и приватно',
        securePrivateDesc: 'Ваши данные зашифрованы и защищены',
        instantResults: 'Мгновенные результаты',
        instantResultsDesc: 'Получите рекомендации за секунды',
        recentAssessments: 'Недавние оценки',
        quickActions: 'Быстрые действия',
        healthOverview: 'Обзор здоровья',
        totalAssessments: 'Всего оценок',
        viewAll: 'Смотреть все',
        noAssessments: 'Нет оценок',
        startFirstAssessment: 'Начните вашу первую оценку',
        email: 'Email',
        password: 'Пароль',
        confirmPassword: 'Подтвердите пароль',
        forgotPassword: 'Забыли пароль?',
        rememberMe: 'Запомнить меня',
        dontHaveAccount: 'Нет аккаунта?',
        alreadyHaveAccount: 'Уже есть аккаунт?',
        signUp: 'Регистрация',
        signIn: 'Вход',
        orContinueWith: 'Или продолжить с',
        continueWithGoogle: 'Продолжить с Google',
        createAccount: 'Создать аккаунт',
        welcomeTo: 'Добро пожаловать в',
        profile: 'Профиль',
        account: 'Аккаунт',
        ownerPanel: 'Панель владельца',
        name: 'Имя',
        phone: 'Телефон',
        address: 'Адрес',
        dateOfBirth: 'Дата рождения',
        gender: 'Пол',
        male: 'Мужской',
        female: 'Женский',
        other: 'Другой',
        categories: 'Категории',
        articles: 'Статьи',
        searchArticles: 'Поиск статей...',
        readMore: 'Читать далее',
        possibleConditions: 'Возможные состояния',
        recommendations: 'Рекомендации',
        immediateAction: 'Немедленные действия',
        whenToSeekCare: 'Когда обращаться за помощью',
        selfCare: 'Самопомощь',
        firstAidTips: 'Советы по первой помощи',
        investigations: 'Обследования',
        treatmentOptions: 'Варианты лечения',
        expectedOutcome: 'Ожидаемый результат',
        disclaimer: 'Отказ от ответственности',
        disclaimerText: 'Эта оценка носит информационный характер и не заменяет профессиональную медицинскую консультацию.',
        exportPDF: 'Экспорт PDF',
        shareResults: 'Поделиться результатами',
        getBestExperience: 'Получите лучший опыт',
        worksOffline: 'Работает офлайн • Быстрый доступ • Бесплатно навсегда',
        joinAsProvider: 'Присоединиться как медицинский работник',
        quickResults: 'Быстрые результаты',
        underSeconds: 'Менее 30 секунд',
        backToDashboard: 'Вернуться на панель',
        backToLibrary: 'Вернуться в библиотеку',
        profileInformation: 'Информация профиля',
        updatePersonalDetails: 'Обновите личные данные',
        changePhoto: 'Изменить фото',
        jpgPngGif: 'JPG, PNG или GIF. Макс 5МБ',
        fullName: 'Полное имя',
        phoneNumber: 'Номер телефона',
        gpDoctorDetails: 'Данные врача',
        primaryCarePhysician: 'Информация о вашем лечащем враче',
        doctorName: 'Имя врача',
        practiceAddress: 'Адрес клиники',
        emergencyContactInfo: 'Контактная информация для экстренных случаев',
        relationship: 'Родственная связь',
        saveChanges: 'Сохранить изменения',
        manageProfile: 'Управление профилем и настройками',
        assessmentHistory: 'История оценок',
        viewAndManage: 'Просмотр и управление предыдущими оценками',
        allAssessments: 'Все оценки',
        newCheck: 'Новая проверка',
        noAssessmentsYet: 'Пока нет оценок',
        startFirstSymptomCheck: 'Начните первую проверку симптомов',
        today: 'Сегодня',
        yesterday: 'Вчера',
        daysAgo: 'дней назад',
        deleteAssessment: 'Удалить оценку',
        areYouSureDelete: 'Вы уверены, что хотите удалить эту оценку? Это действие нельзя отменить.',
        yourProfile: 'Ваш профиль',
        managePersonalInfo: 'Управление личной информацией',
        personal: 'Личное',
        yourHealthAssessment: 'Ваша оценка здоровья',
        imageAnalyzed: 'Изображение проанализировано',
        downloadPDF: 'Скачать PDF',
        shareWithDoctor: 'Поделиться с врачом',
        generating: 'Генерация...',
        callEmergencyServices: 'Вызвать скорую помощь',
        reportedSymptoms: 'Указанные симптомы',
        bodyParts: 'Части тела',
        loadingDiagnosis: 'Загрузка диагноза...',
        errorLoadingDiagnosis: 'Ошибка загрузки диагноза',
        returnToDashboard: 'Вернуться на панель',
        trackHealthPatterns: 'Отслеживайте паттерны здоровья и устанавливайте напоминания',
        addEntry: 'Добавить запись',
        setReminder: 'Установить напоминание',
        patientInfoLeaflets: 'Информационные листки для пациентов и ресурсы здоровья',
        searchConditions: 'Поиск состояний, процедур...',
        conditions: 'Состояния',
        procedures: 'Процедуры',
        resources: 'Ресурсы',
        overview: 'Обзор',
        causesRiskFactors: 'Причины и факторы риска',
        prevention: 'Профилактика',
        whenToSeekMedicalHelp: 'Когда обращаться за медицинской помощью',
        preparation: 'Подготовка',
        theProcedure: 'Процедура',
        aftercare: 'Послеоперационный уход',
        results: 'Результаты',
        forGeneralGuidance: 'Эта информация носит общий характер. Всегда консультируйтесь с врачом для получения персонализированных рекомендаций.',
        trackHealthAssessments: 'Отслеживайте оценки здоровья и получайте ИИ-аналитику.',
        newSymptomCheck: 'Новая проверка симптомов',
        getAiPoweredAssessment: 'Получите оценку здоровья на базе ИИ',
        totalChecks: 'Всего проверок',
        latestSymptomChecks: 'Ваши последние проверки симптомов',
        startYourFirstCheck: 'Начните первую проверку',
        languageSettings: 'Настройки языка',
        selectPreferredLanguage: 'Выберите предпочтительный язык интерфейса',
        currentLanguage: 'Текущий язык',
        someMedicalContent: 'Некоторый медицинский контент может отображаться на английском для точности.',
    },
    
    pt: {
        dashboard: 'Painel',
        checkSymptoms: 'Verificar sintomas',
        history: 'Histórico',
        healthLibrary: 'Biblioteca de saúde',
        healthDiary: 'Diário de saúde',
        consultations: 'Consultas',
        referrals: 'Encaminhamentos',
        prescriptions: 'Receitas',
        findCare: 'Encontrar atendimento',
        settings: 'Configurações',
        subscription: 'Assinatura',
        logout: 'Sair',
        login: 'Entrar',
        register: 'Começar',
        submit: 'Enviar',
        cancel: 'Cancelar',
        save: 'Salvar',
        next: 'Próximo',
        back: 'Voltar',
        close: 'Fechar',
        loading: 'Carregando...',
        search: 'Pesquisar',
        filter: 'Filtrar',
        delete: 'Excluir',
        edit: 'Editar',
        view: 'Ver',
        download: 'Baixar',
        share: 'Compartilhar',
        copy: 'Copiar',
        selectBodyParts: 'Selecione as partes do corpo afetadas',
        describeSymptoms: 'Descreva seus sintomas',
        duration: 'Duração',
        severity: 'Gravidade',
        medicalHistory: 'Histórico médico',
        additionalInfo: 'Informações adicionais',
        startAssessment: 'Iniciar avaliação',
        viewResults: 'Ver resultados',
        newAssessment: 'Nova avaliação',
        lessThan24Hours: 'Menos de 24 horas',
        oneToThreeDays: '1-3 dias',
        fourToSevenDays: '4-7 dias',
        oneToTwoWeeks: '1-2 semanas',
        moreThanTwoWeeks: 'Mais de 2 semanas',
        mild: 'Leve',
        moderate: 'Moderada',
        severe: 'Grave',
        emergency: 'Emergência',
        urgent: 'Urgente',
        routine: 'Rotina',
        freeTrial: 'Teste gratuito',
        upgradeNow: 'Atualizar agora',
        viewPlans: 'Ver planos',
        checksRemaining: 'verificações restantes',
        unlimited: 'Ilimitado',
        currentPlan: 'Plano atual',
        chooseYourPlan: 'Escolha seu plano',
        pricesShownIn: 'Preços em',
        completePayment: 'Concluir pagamento',
        choosePaymentMethod: 'Escolha o método de pagamento',
        payWithCard: 'Pagar com cartão',
        securePayment: 'Pagamento seguro via Stripe',
        processingPayment: 'Processando pagamento...',
        pleaseWait: 'Por favor, aguarde. Não feche esta janela.',
        selected: 'Selecionado',
        selectPlan: 'Selecionar',
        mostPopular: 'Mais popular',
        payPerUse: 'Pague por uso',
        basicMonthly: 'Básico mensal',
        premiumMonthly: 'Premium mensal',
        perCheck: 'por verificação',
        perMonth: '/mês',
        payOnlyWhenNeeded: 'Pague apenas quando precisar',
        unlimitedForIndividuals: 'Verificações ilimitadas',
        fullAccessPremium: 'Acesso completo + premium',
        singleSymptomCheck: 'Verificação única de sintomas',
        aiPoweredAssessment: 'Avaliação por IA',
        shareWithDoctor: 'Compartilhar com médico',
        pdfExport: 'Exportar PDF',
        medicalHistoryTracking: 'Rastreamento de histórico',
        photoUploadAnalysis: 'Análise de fotos',
        everythingInBasic: 'Tudo do Básico',
        bookOnlineConsultations: 'Consultas online*',
        requestPrescriptions: 'Solicitar receitas*',
        specialtyReferrals: 'Encaminhamentos*',
        prioritySupport: 'Suporte prioritário',
        additionalFeesApply: '* Taxas adicionais',
        youHaveUnlimitedChecks: 'Você tem verificações ilimitadas',
        yourFreeTrialEnded: 'Teste expirou. Escolha um plano.',
        language: 'Idioma',
        selectLanguage: 'Selecionar idioma',
        theme: 'Tema',
        darkMode: 'Modo escuro',
        lightMode: 'Modo claro',
        gpDetails: 'Dados do médico',
        nextOfKin: 'Parente próximo',
        welcomeBack: 'Bem-vindo de volta',
        trialExhausted: 'Teste gratuito esgotado',
        upgradeToContnue: 'Atualize para continuar',
        noResults: 'Nenhum resultado encontrado',
        errorOccurred: 'Ocorreu um erro',
        savedSuccessfully: 'Salvo com sucesso',
        shareApp: 'Compartilhar aplicativo',
        installApp: 'Instalar aplicativo',
        heroTitle: 'Avaliação de saúde por IA',
        heroSubtitle: 'Obtenha insights de saúde personalizados instantâneos',
        getStartedFree: 'Comece grátis',
        learnMore: 'Saiba mais',
        whyChooseUs: 'Por que escolher MediGuide',
        howItWorks: 'Como funciona',
        features: 'Recursos',
        aiPowered: 'Análise por IA',
        aiPoweredDesc: 'IA analisa seus sintomas para insights precisos',
        available247: 'Disponível 24/7',
        available247Desc: 'Obtenha orientação de saúde a qualquer momento',
        securePrivate: 'Seguro e privado',
        securePrivateDesc: 'Seus dados de saúde são criptografados e protegidos',
        instantResults: 'Resultados instantâneos',
        instantResultsDesc: 'Obtenha recomendações em segundos',
        recentAssessments: 'Avaliações recentes',
        quickActions: 'Ações rápidas',
        healthOverview: 'Visão geral da saúde',
        totalAssessments: 'Total de avaliações',
        viewAll: 'Ver tudo',
        noAssessments: 'Sem avaliações',
        startFirstAssessment: 'Comece sua primeira avaliação',
        email: 'Email',
        password: 'Senha',
        confirmPassword: 'Confirmar senha',
        forgotPassword: 'Esqueceu a senha?',
        rememberMe: 'Lembrar de mim',
        dontHaveAccount: 'Não tem uma conta?',
        alreadyHaveAccount: 'Já tem uma conta?',
        signUp: 'Cadastrar',
        signIn: 'Entrar',
        orContinueWith: 'Ou continue com',
        continueWithGoogle: 'Continuar com Google',
        createAccount: 'Criar conta',
        welcomeTo: 'Bem-vindo ao',
        profile: 'Perfil',
        account: 'Conta',
        ownerPanel: 'Painel do proprietário',
        name: 'Nome',
        phone: 'Telefone',
        address: 'Endereço',
        dateOfBirth: 'Data de nascimento',
        gender: 'Gênero',
        male: 'Masculino',
        female: 'Feminino',
        other: 'Outro',
        categories: 'Categorias',
        articles: 'Artigos',
        searchArticles: 'Pesquisar artigos...',
        readMore: 'Leia mais',
        possibleConditions: 'Condições possíveis',
        recommendations: 'Recomendações',
        immediateAction: 'Ação imediata',
        whenToSeekCare: 'Quando procurar atendimento',
        selfCare: 'Autocuidado',
        firstAidTips: 'Dicas de primeiros socorros',
        investigations: 'Exames',
        treatmentOptions: 'Opções de tratamento',
        expectedOutcome: 'Resultado esperado',
        disclaimer: 'Aviso',
        disclaimerText: 'Esta avaliação é apenas para fins informativos e não substitui o aconselhamento médico profissional.',
        exportPDF: 'Exportar PDF',
        shareResults: 'Compartilhar resultados',
        getBestExperience: 'Obtenha a melhor experiência',
        worksOffline: 'Funciona offline • Acesso rápido • Grátis para sempre',
        joinAsProvider: 'Junte-se como profissional de saúde',
        quickResults: 'Resultados rápidos',
        underSeconds: 'Menos de 30 segundos',
        backToDashboard: 'Voltar ao painel',
        backToLibrary: 'Voltar à biblioteca',
        profileInformation: 'Informações do perfil',
        updatePersonalDetails: 'Atualize seus dados pessoais',
        changePhoto: 'Alterar foto',
        jpgPngGif: 'JPG, PNG ou GIF. Máx 5MB',
        fullName: 'Nome completo',
        phoneNumber: 'Número de telefone',
        gpDoctorDetails: 'Detalhes do médico',
        primaryCarePhysician: 'Informações do seu médico de família',
        doctorName: 'Nome do médico',
        practiceAddress: 'Endereço do consultório',
        emergencyContactInfo: 'Informações de contato de emergência',
        relationship: 'Relacionamento',
        saveChanges: 'Salvar alterações',
        manageProfile: 'Gerencie seu perfil e configurações',
        assessmentHistory: 'Histórico de avaliações',
        viewAndManage: 'Visualize e gerencie avaliações anteriores',
        allAssessments: 'Todas as avaliações',
        newCheck: 'Nova verificação',
        noAssessmentsYet: 'Nenhuma avaliação ainda',
        startFirstSymptomCheck: 'Comece sua primeira verificação de sintomas',
        today: 'Hoje',
        yesterday: 'Ontem',
        daysAgo: 'dias atrás',
        deleteAssessment: 'Excluir avaliação',
        areYouSureDelete: 'Tem certeza que deseja excluir esta avaliação? Esta ação não pode ser desfeita.',
        yourProfile: 'Seu perfil',
        managePersonalInfo: 'Gerencie suas informações pessoais',
        personal: 'Pessoal',
        yourHealthAssessment: 'Sua avaliação de saúde',
        imageAnalyzed: 'Imagem analisada',
        downloadPDF: 'Baixar PDF',
        shareWithDoctor: 'Compartilhar com o médico',
        generating: 'Gerando...',
        callEmergencyServices: 'Ligar para emergência',
        reportedSymptoms: 'Sintomas relatados',
        bodyParts: 'Partes do corpo',
        loadingDiagnosis: 'Carregando diagnóstico...',
        errorLoadingDiagnosis: 'Erro ao carregar diagnóstico',
        returnToDashboard: 'Voltar ao painel',
        trackHealthPatterns: 'Acompanhe seus padrões de saúde e defina lembretes',
        addEntry: 'Adicionar entrada',
        setReminder: 'Definir lembrete',
        patientInfoLeaflets: 'Folhetos informativos para pacientes e recursos de saúde',
        searchConditions: 'Pesquisar condições, procedimentos...',
        conditions: 'Condições',
        procedures: 'Procedimentos',
        resources: 'Recursos',
        overview: 'Visão geral',
        causesRiskFactors: 'Causas e fatores de risco',
        prevention: 'Prevenção',
        whenToSeekMedicalHelp: 'Quando procurar ajuda médica',
        preparation: 'Preparação',
        theProcedure: 'O procedimento',
        aftercare: 'Cuidados pós-procedimento',
        results: 'Resultados',
        forGeneralGuidance: 'Esta informação é apenas para orientação geral. Sempre consulte seu médico para aconselhamento médico personalizado.',
        trackHealthAssessments: 'Acompanhe suas avaliações de saúde e obtenha insights de IA.',
        newSymptomCheck: 'Nova verificação de sintomas',
        getAiPoweredAssessment: 'Obtenha uma avaliação de saúde com IA',
        totalChecks: 'Total de verificações',
        latestSymptomChecks: 'Suas últimas verificações de sintomas',
        startYourFirstCheck: 'Comece sua primeira verificação',
        languageSettings: 'Configurações de idioma',
        selectPreferredLanguage: 'Selecione seu idioma preferido para a interface',
        currentLanguage: 'Idioma atual',
        someMedicalContent: 'Alguns conteúdos médicos podem aparecer em inglês para maior precisão.',
    },
    
    de: {
        dashboard: 'Dashboard',
        checkSymptoms: 'Symptome prüfen',
        history: 'Verlauf',
        healthLibrary: 'Gesundheitsbibliothek',
        healthDiary: 'Gesundheitstagebuch',
        consultations: 'Konsultationen',
        referrals: 'Überweisungen',
        prescriptions: 'Rezepte',
        findCare: 'Versorgung finden',
        settings: 'Einstellungen',
        subscription: 'Abonnement',
        logout: 'Abmelden',
        login: 'Anmelden',
        register: 'Starten',
        submit: 'Absenden',
        cancel: 'Abbrechen',
        save: 'Speichern',
        next: 'Weiter',
        back: 'Zurück',
        close: 'Schließen',
        loading: 'Laden...',
        search: 'Suchen',
        filter: 'Filtern',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        view: 'Ansehen',
        download: 'Herunterladen',
        share: 'Teilen',
        copy: 'Kopieren',
        selectBodyParts: 'Betroffene Körperteile auswählen',
        describeSymptoms: 'Beschreiben Sie Ihre Symptome',
        duration: 'Dauer',
        severity: 'Schweregrad',
        medicalHistory: 'Krankengeschichte',
        additionalInfo: 'Zusätzliche Informationen',
        startAssessment: 'Bewertung starten',
        viewResults: 'Ergebnisse anzeigen',
        newAssessment: 'Neue Bewertung',
        lessThan24Hours: 'Weniger als 24 Stunden',
        oneToThreeDays: '1-3 Tage',
        fourToSevenDays: '4-7 Tage',
        oneToTwoWeeks: '1-2 Wochen',
        moreThanTwoWeeks: 'Mehr als 2 Wochen',
        mild: 'Leicht',
        moderate: 'Mäßig',
        severe: 'Schwer',
        emergency: 'Notfall',
        urgent: 'Dringend',
        routine: 'Routine',
        freeTrial: 'Kostenlose Testversion',
        upgradeNow: 'Jetzt upgraden',
        viewPlans: 'Pläne anzeigen',
        checksRemaining: 'Prüfungen verbleibend',
        unlimited: 'Unbegrenzt',
        currentPlan: 'Aktueller Plan',
        chooseYourPlan: 'Wählen Sie Ihren Plan',
        pricesShownIn: 'Preise angezeigt in',
        completePayment: 'Zahlung abschließen',
        choosePaymentMethod: 'Wählen Sie Ihre Zahlungsmethode',
        payWithCard: 'Mit Karte zahlen',
        securePayment: 'Sichere Zahlung über Stripe',
        processingPayment: 'Zahlung wird verarbeitet...',
        pleaseWait: 'Bitte warten. Fenster nicht schließen.',
        selected: 'Ausgewählt',
        selectPlan: 'Auswählen',
        mostPopular: 'Am beliebtesten',
        payPerUse: 'Zahlen pro Nutzung',
        basicMonthly: 'Basis monatlich',
        premiumMonthly: 'Premium monatlich',
        perCheck: 'pro Prüfung',
        perMonth: '/Monat',
        payOnlyWhenNeeded: 'Zahlen Sie nur bei Bedarf',
        unlimitedForIndividuals: 'Unbegrenzte Prüfungen',
        fullAccessPremium: 'Voller Zugang + Premium',
        singleSymptomCheck: 'Einzelne Symptomprüfung',
        aiPoweredAssessment: 'KI-gestützte Bewertung',
        shareWithDoctor: 'Mit Arzt teilen',
        pdfExport: 'PDF exportieren',
        medicalHistoryTracking: 'Krankengeschichte verfolgen',
        photoUploadAnalysis: 'Fotoanalyse',
        everythingInBasic: 'Alles aus Basis',
        bookOnlineConsultations: 'Online-Beratungen buchen*',
        requestPrescriptions: 'Rezepte anfordern*',
        specialtyReferrals: 'Facharztüberweisungen*',
        prioritySupport: 'Prioritäts-Support',
        additionalFeesApply: '* Zusätzliche Gebühren',
        youHaveUnlimitedChecks: 'Sie haben unbegrenzte Prüfungen',
        yourFreeTrialEnded: 'Testversion beendet. Wählen Sie einen Plan.',
        language: 'Sprache',
        selectLanguage: 'Sprache auswählen',
        theme: 'Design',
        darkMode: 'Dunkelmodus',
        lightMode: 'Hellmodus',
        gpDetails: 'Arztdaten',
        nextOfKin: 'Nächster Angehöriger',
        welcomeBack: 'Willkommen zurück',
        trialExhausted: 'Testversion erschöpft',
        upgradeToContnue: 'Upgraden Sie, um fortzufahren',
        noResults: 'Keine Ergebnisse gefunden',
        errorOccurred: 'Ein Fehler ist aufgetreten',
        savedSuccessfully: 'Erfolgreich gespeichert',
        shareApp: 'App teilen',
        installApp: 'App installieren',
        heroTitle: 'KI-gestützte Gesundheitsbewertung',
        heroSubtitle: 'Erhalten Sie sofortige, personalisierte Gesundheitseinblicke',
        getStartedFree: 'Kostenlos starten',
        trackHealthAssessments: 'Verfolgen Sie Ihre Gesundheitsbewertungen und erhalten Sie KI-gestützte Einblicke.',
        newSymptomCheck: 'Neue Symptomprüfung',
        getAiPoweredAssessment: 'Erhalten Sie eine KI-gestützte Gesundheitsbewertung',
        totalChecks: 'Gesamtprüfungen',
        latestSymptomChecks: 'Ihre neuesten Symptomprüfungen',
        startYourFirstCheck: 'Starten Sie Ihre erste Prüfung',
        languageSettings: 'Spracheinstellungen',
        selectPreferredLanguage: 'Wählen Sie Ihre bevorzugte Sprache für die Benutzeroberfläche',
        currentLanguage: 'Aktuelle Sprache',
        someMedicalContent: 'Einige medizinische Inhalte werden möglicherweise aus Genauigkeitsgründen auf Englisch angezeigt.',
        learnMore: 'Mehr erfahren',
        whyChooseUs: 'Warum MediGuide',
        howItWorks: 'So funktioniert es',
        features: 'Funktionen',
        aiPowered: 'KI-gestützte Analyse',
        aiPoweredDesc: 'KI analysiert Ihre Symptome für genaue Einblicke',
        available247: 'Rund um die Uhr verfügbar',
        available247Desc: 'Erhalten Sie jederzeit Gesundheitsberatung',
        securePrivate: 'Sicher und privat',
        securePrivateDesc: 'Ihre Gesundheitsdaten sind verschlüsselt und geschützt',
        instantResults: 'Sofortige Ergebnisse',
        instantResultsDesc: 'Erhalten Sie Empfehlungen in Sekunden',
        recentAssessments: 'Aktuelle Bewertungen',
        quickActions: 'Schnellaktionen',
        healthOverview: 'Gesundheitsübersicht',
        totalAssessments: 'Gesamte Bewertungen',
        viewAll: 'Alle anzeigen',
        noAssessments: 'Keine Bewertungen',
        startFirstAssessment: 'Starten Sie Ihre erste Bewertung',
        email: 'E-Mail',
        password: 'Passwort',
        confirmPassword: 'Passwort bestätigen',
        forgotPassword: 'Passwort vergessen?',
        rememberMe: 'Angemeldet bleiben',
        dontHaveAccount: 'Kein Konto?',
        alreadyHaveAccount: 'Bereits ein Konto?',
        signUp: 'Registrieren',
        signIn: 'Anmelden',
        orContinueWith: 'Oder fortfahren mit',
        continueWithGoogle: 'Mit Google fortfahren',
        createAccount: 'Konto erstellen',
        welcomeTo: 'Willkommen bei',
        profile: 'Profil',
        account: 'Konto',
        ownerPanel: 'Besitzer-Panel',
        name: 'Name',
        phone: 'Telefon',
        address: 'Adresse',
        dateOfBirth: 'Geburtsdatum',
        gender: 'Geschlecht',
        male: 'Männlich',
        female: 'Weiblich',
        other: 'Andere',
        categories: 'Kategorien',
        articles: 'Artikel',
        searchArticles: 'Artikel suchen...',
        readMore: 'Mehr lesen',
        possibleConditions: 'Mögliche Erkrankungen',
        recommendations: 'Empfehlungen',
        immediateAction: 'Sofortmaßnahme',
        whenToSeekCare: 'Wann Sie Hilfe suchen sollten',
        selfCare: 'Selbstpflege',
        firstAidTips: 'Erste-Hilfe-Tipps',
        investigations: 'Untersuchungen',
        treatmentOptions: 'Behandlungsoptionen',
        expectedOutcome: 'Erwartetes Ergebnis',
        disclaimer: 'Haftungsausschluss',
        disclaimerText: 'Diese Bewertung dient nur zu Informationszwecken und ersetzt keine professionelle medizinische Beratung.',
        exportPDF: 'PDF exportieren',
        shareResults: 'Ergebnisse teilen',
        getBestExperience: 'Das beste Erlebnis erhalten',
        worksOffline: 'Funktioniert offline • Schneller Zugriff • Für immer kostenlos',
        joinAsProvider: 'Als Gesundheitsdienstleister beitreten',
        quickResults: 'Schnelle Ergebnisse',
        underSeconds: 'Unter 30 Sekunden',
        backToDashboard: 'Zurück zum Dashboard',
        backToLibrary: 'Zurück zur Bibliothek',
        profileInformation: 'Profilinformationen',
        updatePersonalDetails: 'Aktualisieren Sie Ihre persönlichen Daten',
        changePhoto: 'Foto ändern',
        jpgPngGif: 'JPG, PNG oder GIF. Max 5MB',
        fullName: 'Vollständiger Name',
        phoneNumber: 'Telefonnummer',
        gpDoctorDetails: 'Arztdetails',
        primaryCarePhysician: 'Informationen zu Ihrem Hausarzt',
        doctorName: 'Name des Arztes',
        practiceAddress: 'Praxisadresse',
        emergencyContactInfo: 'Notfallkontakt-Informationen',
        relationship: 'Beziehung',
        saveChanges: 'Änderungen speichern',
        manageProfile: 'Verwalten Sie Ihr Profil und Ihre Einstellungen',
        assessmentHistory: 'Bewertungsverlauf',
        viewAndManage: 'Frühere Bewertungen anzeigen und verwalten',
        allAssessments: 'Alle Bewertungen',
        newCheck: 'Neue Überprüfung',
        noAssessmentsYet: 'Noch keine Bewertungen',
        startFirstSymptomCheck: 'Starten Sie Ihre erste Symptomüberprüfung',
        today: 'Heute',
        yesterday: 'Gestern',
        daysAgo: 'Tage her',
        deleteAssessment: 'Bewertung löschen',
        areYouSureDelete: 'Sind Sie sicher, dass Sie diese Bewertung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        yourProfile: 'Ihr Profil',
        managePersonalInfo: 'Verwalten Sie Ihre persönlichen Informationen',
        personal: 'Persönlich',
        yourHealthAssessment: 'Ihre Gesundheitsbewertung',
        imageAnalyzed: 'Bild analysiert',
        downloadPDF: 'PDF herunterladen',
        shareWithDoctor: 'Mit dem Arzt teilen',
        generating: 'Wird generiert...',
        callEmergencyServices: 'Notdienst anrufen',
        reportedSymptoms: 'Gemeldete Symptome',
        bodyParts: 'Körperteile',
        loadingDiagnosis: 'Diagnose wird geladen...',
        errorLoadingDiagnosis: 'Fehler beim Laden der Diagnose',
        returnToDashboard: 'Zurück zum Dashboard',
        trackHealthPatterns: 'Verfolgen Sie Ihre Gesundheitsmuster und setzen Sie Erinnerungen',
        addEntry: 'Eintrag hinzufügen',
        setReminder: 'Erinnerung setzen',
        patientInfoLeaflets: 'Patienteninformationsblätter und Gesundheitsressourcen',
        searchConditions: 'Krankheiten, Verfahren suchen...',
        conditions: 'Erkrankungen',
        procedures: 'Verfahren',
        resources: 'Ressourcen',
        overview: 'Überblick',
        causesRiskFactors: 'Ursachen und Risikofaktoren',
        prevention: 'Prävention',
        whenToSeekMedicalHelp: 'Wann Sie einen Arzt aufsuchen sollten',
        preparation: 'Vorbereitung',
        theProcedure: 'Der Eingriff',
        aftercare: 'Nachsorge',
        results: 'Ergebnisse',
        forGeneralGuidance: 'Diese Informationen dienen nur zur allgemeinen Orientierung. Wenden Sie sich für persönliche medizinische Beratung immer an Ihren Arzt.',
    },
    
    lt: {
        dashboard: 'Valdymo skydelis',
        checkSymptoms: 'Tikrinti simptomus',
        history: 'Istorija',
        healthLibrary: 'Sveikatos biblioteka',
        healthDiary: 'Sveikatos dienoraštis',
        consultations: 'Konsultacijos',
        referrals: 'Siuntimai',
        prescriptions: 'Receptai',
        findCare: 'Rasti priežiūrą',
        settings: 'Nustatymai',
        subscription: 'Prenumerata',
        logout: 'Atsijungti',
        login: 'Prisijungti',
        register: 'Pradėti',
        submit: 'Pateikti',
        cancel: 'Atšaukti',
        save: 'Išsaugoti',
        next: 'Kitas',
        back: 'Atgal',
        close: 'Uždaryti',
        loading: 'Kraunama...',
        search: 'Ieškoti',
        filter: 'Filtruoti',
        delete: 'Ištrinti',
        edit: 'Redaguoti',
        view: 'Peržiūrėti',
        download: 'Atsisiųsti',
        share: 'Dalintis',
        copy: 'Kopijuoti',
        selectBodyParts: 'Pasirinkite paveiktas kūno dalis',
        describeSymptoms: 'Apibūdinkite savo simptomus',
        duration: 'Trukmė',
        severity: 'Sunkumas',
        medicalHistory: 'Medicininė istorija',
        additionalInfo: 'Papildoma informacija',
        startAssessment: 'Pradėti vertinimą',
        viewResults: 'Peržiūrėti rezultatus',
        newAssessment: 'Naujas vertinimas',
        lessThan24Hours: 'Mažiau nei 24 valandos',
        oneToThreeDays: '1-3 dienos',
        fourToSevenDays: '4-7 dienos',
        oneToTwoWeeks: '1-2 savaitės',
        moreThanTwoWeeks: 'Daugiau nei 2 savaitės',
        mild: 'Lengvas',
        moderate: 'Vidutinis',
        severe: 'Sunkus',
        emergency: 'Skubus atvejis',
        urgent: 'Skubu',
        routine: 'Įprasta',
        freeTrial: 'Nemokamas bandymas',
        upgradeNow: 'Atnaujinti dabar',
        viewPlans: 'Peržiūrėti planus',
        checksRemaining: 'likusių patikrinimų',
        unlimited: 'Neribota',
        currentPlan: 'Dabartinis planas',
        chooseYourPlan: 'Pasirinkite planą',
        pricesShownIn: 'Kainos rodomos',
        completePayment: 'Užbaigti mokėjimą',
        choosePaymentMethod: 'Pasirinkite mokėjimo būdą',
        payWithCard: 'Mokėti kortele',
        securePayment: 'Saugus mokėjimas per Stripe',
        processingPayment: 'Apdorojamas mokėjimas...',
        pleaseWait: 'Prašome palaukti. Neuždarykite lango.',
        selected: 'Pasirinkta',
        selectPlan: 'Pasirinkti',
        mostPopular: 'Populiariausias',
        payPerUse: 'Mokėti už naudojimą',
        basicMonthly: 'Bazinis mėnesinis',
        premiumMonthly: 'Premium mėnesinis',
        perCheck: 'už patikrinimą',
        perMonth: '/mėn',
        payOnlyWhenNeeded: 'Mokėkite tik kai reikia',
        unlimitedForIndividuals: 'Neriboti patikrinimai',
        fullAccessPremium: 'Pilna prieiga + premium',
        singleSymptomCheck: 'Vienas simptomų patikrinimas',
        aiPoweredAssessment: 'AI vertinimas',
        shareWithDoctor: 'Dalintis su gydytoju',
        pdfExport: 'PDF eksportas',
        medicalHistoryTracking: 'Istorijos sekimas',
        photoUploadAnalysis: 'Nuotraukų analizė',
        everythingInBasic: 'Viskas iš Bazinio',
        bookOnlineConsultations: 'Konsultacijos internetu*',
        requestPrescriptions: 'Prašyti receptų*',
        specialtyReferrals: 'Specialistų siuntimai*',
        prioritySupport: 'Prioritetinė pagalba',
        additionalFeesApply: '* Papildomi mokesčiai',
        youHaveUnlimitedChecks: 'Turite neribotus patikrinimus',
        yourFreeTrialEnded: 'Bandymas baigėsi. Pasirinkite planą.',
        language: 'Kalba',
        selectLanguage: 'Pasirinkite kalbą',
        theme: 'Tema',
        darkMode: 'Tamsusis režimas',
        lightMode: 'Šviesusis režimas',
        gpDetails: 'Gydytojo duomenys',
        nextOfKin: 'Artimiausi giminaičiai',
        welcomeBack: 'Sveiki sugrįžę',
        trialExhausted: 'Nemokamas bandymas baigėsi',
        upgradeToContnue: 'Atnaujinkite, kad tęstumėte',
        noResults: 'Rezultatų nerasta',
        errorOccurred: 'Įvyko klaida',
        savedSuccessfully: 'Sėkmingai išsaugota',
        shareApp: 'Dalintis programa',
        installApp: 'Įdiegti programą',
        heroTitle: 'AI sveikatos vertinimas',
        heroSubtitle: 'Gaukite momentinius personalizuotus sveikatos įžvalgas',
        getStartedFree: 'Pradėti nemokamai',
        learnMore: 'Sužinoti daugiau',
        whyChooseUs: 'Kodėl MediGuide',
        howItWorks: 'Kaip tai veikia',
        features: 'Funkcijos',
        aiPowered: 'AI paremta analizė',
        aiPoweredDesc: 'AI analizuoja jūsų simptomus tiksliems įžvalgoms',
        available247: 'Prieinama visą parą',
        available247Desc: 'Gaukite sveikatos patarimus bet kada',
        securePrivate: 'Saugu ir privatu',
        securePrivateDesc: 'Jūsų sveikatos duomenys yra užšifruoti ir apsaugoti',
        instantResults: 'Momentiniai rezultatai',
        instantResultsDesc: 'Gaukite rekomendacijas per sekundes',
        recentAssessments: 'Naujausi vertinimai',
        quickActions: 'Greiti veiksmai',
        healthOverview: 'Sveikatos apžvalga',
        totalAssessments: 'Iš viso vertinimų',
        viewAll: 'Peržiūrėti viską',
        noAssessments: 'Nėra vertinimų',
        startFirstAssessment: 'Pradėkite savo pirmąjį vertinimą',
        email: 'El. paštas',
        password: 'Slaptažodis',
        confirmPassword: 'Patvirtinti slaptažodį',
        forgotPassword: 'Pamiršote slaptažodį?',
        rememberMe: 'Prisiminti mane',
        dontHaveAccount: 'Neturite paskyros?',
        alreadyHaveAccount: 'Jau turite paskyrą?',
        signUp: 'Registruotis',
        signIn: 'Prisijungti',
        orContinueWith: 'Arba tęsti su',
        continueWithGoogle: 'Tęsti su Google',
        createAccount: 'Sukurti paskyrą',
        welcomeTo: 'Sveiki atvykę į',
        profile: 'Profilis',
        account: 'Paskyra',
        ownerPanel: 'Savininko skydelis',
        name: 'Vardas',
        phone: 'Telefonas',
        address: 'Adresas',
        dateOfBirth: 'Gimimo data',
        gender: 'Lytis',
        male: 'Vyras',
        female: 'Moteris',
        other: 'Kita',
        categories: 'Kategorijos',
        articles: 'Straipsniai',
        searchArticles: 'Ieškoti straipsnių...',
        readMore: 'Skaityti daugiau',
        possibleConditions: 'Galimos būklės',
        recommendations: 'Rekomendacijos',
        immediateAction: 'Neatidėliotinas veiksmas',
        whenToSeekCare: 'Kada kreiptis pagalbos',
        selfCare: 'Savitvarka',
        firstAidTips: 'Pirmosios pagalbos patarimai',
        investigations: 'Tyrimai',
        treatmentOptions: 'Gydymo galimybės',
        expectedOutcome: 'Tikėtinas rezultatas',
        disclaimer: 'Atsakomybės atsisakymas',
        disclaimerText: 'Šis vertinimas skirtas tik informaciniams tikslams ir nepakeičia profesionalios medicininės konsultacijos.',
        exportPDF: 'Eksportuoti PDF',
        shareResults: 'Dalintis rezultatais',
        getBestExperience: 'Gaukite geriausią patirtį',
        worksOffline: 'Veikia neprisijungus • Greita prieiga • Nemokama visam laikui',
        joinAsProvider: 'Prisijunkite kaip sveikatos priežiūros specialistas',
        quickResults: 'Greiti rezultatai',
        underSeconds: 'Mažiau nei 30 sekundžių',
        backToDashboard: 'Grįžti į valdymo skydelį',
        backToLibrary: 'Grįžti į biblioteką',
        profileInformation: 'Profilio informacija',
        updatePersonalDetails: 'Atnaujinkite savo asmeninius duomenis',
        changePhoto: 'Pakeisti nuotrauką',
        jpgPngGif: 'JPG, PNG arba GIF. Maks 5MB',
        fullName: 'Pilnas vardas',
        phoneNumber: 'Telefono numeris',
        gpDoctorDetails: 'Gydytojo duomenys',
        primaryCarePhysician: 'Jūsų šeimos gydytojo informacija',
        doctorName: 'Gydytojo vardas',
        practiceAddress: 'Klinikos adresas',
        emergencyContactInfo: 'Avarinės situacijos kontaktinė informacija',
        relationship: 'Ryšys',
        saveChanges: 'Išsaugoti pakeitimus',
        manageProfile: 'Tvarkykite profilį ir nustatymus',
        assessmentHistory: 'Vertinimų istorija',
        viewAndManage: 'Peržiūrėkite ir tvarkykite ankstesnius vertinimus',
        allAssessments: 'Visi vertinimai',
        newCheck: 'Naujas patikrinimas',
        noAssessmentsYet: 'Dar nėra vertinimų',
        startFirstSymptomCheck: 'Pradėkite pirmą simptomų patikrinimą',
        today: 'Šiandien',
        yesterday: 'Vakar',
        daysAgo: 'dienų prieš',
        deleteAssessment: 'Ištrinti vertinimą',
        areYouSureDelete: 'Ar tikrai norite ištrinti šį vertinimą? Šio veiksmo negalima atšaukti.',
        yourProfile: 'Jūsų profilis',
        managePersonalInfo: 'Tvarkykite savo asmeninę informaciją',
        personal: 'Asmeninis',
        yourHealthAssessment: 'Jūsų sveikatos vertinimas',
        imageAnalyzed: 'Vaizdas išanalizuotas',
        downloadPDF: 'Atsisiųsti PDF',
        shareWithDoctor: 'Dalintis su gydytoju',
        generating: 'Generuojama...',
        callEmergencyServices: 'Skambinti pagalbos tarnyboms',
        reportedSymptoms: 'Pranešti simptomai',
        bodyParts: 'Kūno dalys',
        loadingDiagnosis: 'Kraunama diagnozė...',
        errorLoadingDiagnosis: 'Klaida kraunant diagnozę',
        returnToDashboard: 'Grįžti į valdymo skydelį',
        trackHealthPatterns: 'Stebėkite savo sveikatos tendencijas ir nustatykite priminimus',
        addEntry: 'Pridėti įrašą',
        setReminder: 'Nustatyti priminimą',
        patientInfoLeaflets: 'Pacientų informaciniai lankstinukai ir sveikatos ištekliai',
        searchConditions: 'Ieškoti būklių, procedūrų...',
        conditions: 'Būklės',
        procedures: 'Procedūros',
        resources: 'Ištekliai',
        overview: 'Apžvalga',
        causesRiskFactors: 'Priežastys ir rizikos veiksniai',
        prevention: 'Prevencija',
        whenToSeekMedicalHelp: 'Kada kreiptis medicininės pagalbos',
        preparation: 'Pasiruošimas',
        theProcedure: 'Procedūra',
        aftercare: 'Priežiūra po procedūros',
        results: 'Rezultatai',
        forGeneralGuidance: 'Ši informacija skirta tik bendram orientavimui. Visada pasitarkite su gydytoju dėl individualizuotų medicininių patarimų.',
        trackHealthAssessments: 'Stebėkite savo sveikatos vertinimus ir gaukite AI įžvalgas.',
        newSymptomCheck: 'Naujas simptomų patikrinimas',
        getAiPoweredAssessment: 'Gaukite AI paremtą sveikatos vertinimą',
        totalChecks: 'Iš viso patikrinimų',
        latestSymptomChecks: 'Jūsų naujausi simptomų patikrinimai',
        startYourFirstCheck: 'Pradėkite pirmą patikrinimą',
        languageSettings: 'Kalbos nustatymai',
        selectPreferredLanguage: 'Pasirinkite pageidaujamą sąsajos kalbą',
        currentLanguage: 'Dabartinė kalba',
        someMedicalContent: 'Dalis medicininio turinio gali būti rodoma anglų kalba tikslumui užtikrinti.',
    },
    
    hu: {
        dashboard: 'Irányítópult',
        checkSymptoms: 'Tünetek ellenőrzése',
        history: 'Előzmények',
        healthLibrary: 'Egészségügyi könyvtár',
        healthDiary: 'Egészségnapló',
        consultations: 'Konzultációk',
        referrals: 'Beutalók',
        prescriptions: 'Receptek',
        findCare: 'Ellátás keresése',
        settings: 'Beállítások',
        subscription: 'Előfizetés',
        logout: 'Kijelentkezés',
        login: 'Bejelentkezés',
        register: 'Kezdés',
        submit: 'Beküldés',
        cancel: 'Mégse',
        save: 'Mentés',
        next: 'Következő',
        back: 'Vissza',
        close: 'Bezárás',
        loading: 'Betöltés...',
        search: 'Keresés',
        filter: 'Szűrés',
        delete: 'Törlés',
        edit: 'Szerkesztés',
        view: 'Megtekintés',
        download: 'Letöltés',
        share: 'Megosztás',
        copy: 'Másolás',
        selectBodyParts: 'Válassza ki az érintett testrészeket',
        describeSymptoms: 'Írja le a tüneteit',
        duration: 'Időtartam',
        severity: 'Súlyosság',
        medicalHistory: 'Kórtörténet',
        additionalInfo: 'További információk',
        startAssessment: 'Értékelés indítása',
        viewResults: 'Eredmények megtekintése',
        newAssessment: 'Új értékelés',
        lessThan24Hours: 'Kevesebb mint 24 óra',
        oneToThreeDays: '1-3 nap',
        fourToSevenDays: '4-7 nap',
        oneToTwoWeeks: '1-2 hét',
        moreThanTwoWeeks: 'Több mint 2 hét',
        mild: 'Enyhe',
        moderate: 'Mérsékelt',
        severe: 'Súlyos',
        emergency: 'Sürgősségi',
        urgent: 'Sürgős',
        routine: 'Rutinszerű',
        freeTrial: 'Ingyenes próba',
        upgradeNow: 'Frissítés most',
        viewPlans: 'Csomagok megtekintése',
        checksRemaining: 'ellenőrzés maradt',
        unlimited: 'Korlátlan',
        currentPlan: 'Jelenlegi csomag',
        chooseYourPlan: 'Válasszon csomagot',
        pricesShownIn: 'Árak megjelenítve',
        completePayment: 'Fizetés befejezése',
        choosePaymentMethod: 'Válasszon fizetési módot',
        payWithCard: 'Fizetés kártyával',
        securePayment: 'Biztonságos fizetés Stripe-al',
        processingPayment: 'Fizetés feldolgozása...',
        pleaseWait: 'Kérjük, várjon. Ne zárja be az ablakot.',
        selected: 'Kiválasztva',
        selectPlan: 'Kiválasztás',
        mostPopular: 'Legnépszerűbb',
        payPerUse: 'Fizetés használat után',
        basicMonthly: 'Alap havi',
        premiumMonthly: 'Prémium havi',
        perCheck: 'ellenőrzésenként',
        perMonth: '/hó',
        payOnlyWhenNeeded: 'Fizessen csak ha szükséges',
        unlimitedForIndividuals: 'Korlátlan ellenőrzések',
        fullAccessPremium: 'Teljes hozzáférés + prémium',
        singleSymptomCheck: 'Egyszeri tünetellenőrzés',
        aiPoweredAssessment: 'AI értékelés',
        shareWithDoctor: 'Megosztás orvossal',
        pdfExport: 'PDF exportálás',
        medicalHistoryTracking: 'Kórtörténet követése',
        photoUploadAnalysis: 'Fotóelemzés',
        everythingInBasic: 'Minden az Alapból',
        bookOnlineConsultations: 'Online konzultációk*',
        requestPrescriptions: 'Receptek kérése*',
        specialtyReferrals: 'Szakorvosi beutalók*',
        prioritySupport: 'Kiemelt támogatás',
        additionalFeesApply: '* További díjak',
        youHaveUnlimitedChecks: 'Korlátlan ellenőrzései vannak',
        yourFreeTrialEnded: 'Próba véget ért. Válasszon csomagot.',
        language: 'Nyelv',
        selectLanguage: 'Nyelv kiválasztása',
        theme: 'Téma',
        darkMode: 'Sötét mód',
        lightMode: 'Világos mód',
        gpDetails: 'Orvos adatai',
        nextOfKin: 'Legközelebbi hozzátartozó',
        welcomeBack: 'Üdv újra',
        trialExhausted: 'Ingyenes próba kimerült',
        upgradeToContnue: 'Frissítsen a folytatáshoz',
        noResults: 'Nincs találat',
        errorOccurred: 'Hiba történt',
        savedSuccessfully: 'Sikeresen mentve',
        shareApp: 'Alkalmazás megosztása',
        installApp: 'Alkalmazás telepítése',
        heroTitle: 'AI alapú egészségfelmérés',
        heroSubtitle: 'Kapjon azonnali, személyre szabott egészségügyi tanácsokat',
        getStartedFree: 'Ingyenes kezdés',
        learnMore: 'Tudjon meg többet',
        whyChooseUs: 'Miért MediGuide',
        howItWorks: 'Hogyan működik',
        features: 'Funkciók',
        aiPowered: 'AI-alapú elemzés',
        aiPoweredDesc: 'Az AI elemzi tüneteit a pontos betekintésért',
        available247: 'Éjjel-nappal elérhető',
        available247Desc: 'Kapjon egészségügyi útmutatást bármikor',
        securePrivate: 'Biztonságos és privát',
        securePrivateDesc: 'Egészségügyi adatai titkosítottak és védettek',
        instantResults: 'Azonnali eredmények',
        instantResultsDesc: 'Kapjon ajánlásokat másodpercek alatt',
        recentAssessments: 'Legutóbbi értékelések',
        quickActions: 'Gyors műveletek',
        healthOverview: 'Egészségügyi áttekintés',
        totalAssessments: 'Összes értékelés',
        viewAll: 'Összes megtekintése',
        noAssessments: 'Nincs értékelés',
        startFirstAssessment: 'Kezdje el első értékelését',
        email: 'Email',
        password: 'Jelszó',
        confirmPassword: 'Jelszó megerősítése',
        forgotPassword: 'Elfelejtett jelszó?',
        rememberMe: 'Emlékezz rám',
        dontHaveAccount: 'Nincs fiókja?',
        alreadyHaveAccount: 'Már van fiókja?',
        signUp: 'Regisztráció',
        signIn: 'Bejelentkezés',
        orContinueWith: 'Vagy folytassa ezzel',
        continueWithGoogle: 'Folytatás Google-lal',
        createAccount: 'Fiók létrehozása',
        welcomeTo: 'Üdvözöljük a',
        profile: 'Profil',
        account: 'Fiók',
        ownerPanel: 'Tulajdonos panel',
        name: 'Név',
        phone: 'Telefon',
        address: 'Cím',
        dateOfBirth: 'Születési dátum',
        gender: 'Nem',
        male: 'Férfi',
        female: 'Nő',
        other: 'Egyéb',
        categories: 'Kategóriák',
        articles: 'Cikkek',
        searchArticles: 'Cikkek keresése...',
        readMore: 'Tovább olvasom',
        possibleConditions: 'Lehetséges állapotok',
        recommendations: 'Ajánlások',
        immediateAction: 'Azonnali teendő',
        whenToSeekCare: 'Mikor forduljon orvoshoz',
        selfCare: 'Önellátás',
        firstAidTips: 'Elsősegély tippek',
        investigations: 'Vizsgálatok',
        treatmentOptions: 'Kezelési lehetőségek',
        expectedOutcome: 'Várható eredmény',
        disclaimer: 'Felelősségkizárás',
        disclaimerText: 'Ez az értékelés csak tájékoztató jellegű, és nem helyettesíti a szakorvosi tanácsot.',
        exportPDF: 'PDF exportálás',
        shareResults: 'Eredmények megosztása',
        getBestExperience: 'Szerezze meg a legjobb élményt',
        worksOffline: 'Offline működik • Gyors hozzáférés • Örökre ingyenes',
        joinAsProvider: 'Csatlakozzon egészségügyi szolgáltatóként',
        quickResults: 'Gyors eredmények',
        underSeconds: '30 másodpercen belül',
        backToDashboard: 'Vissza az irányítópultra',
        backToLibrary: 'Vissza a könyvtárba',
        profileInformation: 'Profil információk',
        updatePersonalDetails: 'Frissítse személyes adatait',
        changePhoto: 'Fotó módosítása',
        jpgPngGif: 'JPG, PNG vagy GIF. Max 5MB',
        fullName: 'Teljes név',
        phoneNumber: 'Telefonszám',
        gpDoctorDetails: 'Orvos adatai',
        primaryCarePhysician: 'Háziorvos információi',
        doctorName: 'Orvos neve',
        practiceAddress: 'Rendelő címe',
        emergencyContactInfo: 'Vészhelyzeti kapcsolattartó információ',
        relationship: 'Kapcsolat',
        saveChanges: 'Módosítások mentése',
        manageProfile: 'Kezelje profilját és beállításait',
        assessmentHistory: 'Értékelési előzmények',
        viewAndManage: 'Korábbi értékelések megtekintése és kezelése',
        allAssessments: 'Összes értékelés',
        newCheck: 'Új ellenőrzés',
        noAssessmentsYet: 'Még nincs értékelés',
        startFirstSymptomCheck: 'Kezdje el első tünetellenőrzését',
        today: 'Ma',
        yesterday: 'Tegnap',
        daysAgo: 'napja',
        deleteAssessment: 'Értékelés törlése',
        areYouSureDelete: 'Biztosan törölni szeretné ezt az értékelést? Ez a művelet nem vonható vissza.',
        yourProfile: 'Az Ön profilja',
        managePersonalInfo: 'Kezelje személyes adatait',
        personal: 'Személyes',
        yourHealthAssessment: 'Az Ön egészségügyi értékelése',
        imageAnalyzed: 'Kép elemezve',
        downloadPDF: 'PDF letöltése',
        shareWithDoctor: 'Megosztás orvossal',
        generating: 'Generálás...',
        callEmergencyServices: 'Mentők hívása',
        reportedSymptoms: 'Jelentett tünetek',
        bodyParts: 'Testrészek',
        loadingDiagnosis: 'Diagnózis betöltése...',
        errorLoadingDiagnosis: 'Hiba a diagnózis betöltésekor',
        returnToDashboard: 'Vissza az irányítópultra',
        trackHealthPatterns: 'Kövesse nyomon egészségügyi mintáit és állítson be emlékeztetőket',
        addEntry: 'Bejegyzés hozzáadása',
        setReminder: 'Emlékeztető beállítása',
        patientInfoLeaflets: 'Betégtájékoztató lapok és egészségügyi források',
        searchConditions: 'Állapotok, eljárások keresése...',
        conditions: 'Állapotok',
        procedures: 'Eljárások',
        resources: 'Források',
        overview: 'Áttekintés',
        causesRiskFactors: 'Okok és kockázati tényezők',
        prevention: 'Megelőzés',
        whenToSeekMedicalHelp: 'Mikor forduljon orvoshoz',
        preparation: 'Felkészülés',
        theProcedure: 'Az eljárás',
        aftercare: 'Utógondozás',
        results: 'Eredmények',
        forGeneralGuidance: 'Ez az információ csak általános útmutatásként szolgál. Mindig konzultáljon orvosával személyre szabott orvosi tanácsért.',
        trackHealthAssessments: 'Kövesse nyomon egészségügyi értékeléseit és kapjon AI-alapú betekintést.',
        newSymptomCheck: 'Új tünetellenőrzés',
        getAiPoweredAssessment: 'Kapjon AI-alapú egészségügyi értékelést',
        totalChecks: 'Összes ellenőrzés',
        latestSymptomChecks: 'Legutóbbi tünetellenőrzései',
        startYourFirstCheck: 'Kezdje el első ellenőrzését',
        languageSettings: 'Nyelvi beállítások',
        selectPreferredLanguage: 'Válassza ki a kívánt felületi nyelvet',
        currentLanguage: 'Jelenlegi nyelv',
        someMedicalContent: 'Egyes orvosi tartalmak a pontosság érdekében angolul jelenhetnek meg.',
    },
    
    es: {
        dashboard: 'Panel',
        checkSymptoms: 'Verificar síntomas',
        history: 'Historial',
        healthLibrary: 'Biblioteca de salud',
        healthDiary: 'Diario de salud',
        consultations: 'Consultas',
        referrals: 'Referencias',
        prescriptions: 'Recetas',
        findCare: 'Buscar atención',
        settings: 'Configuración',
        subscription: 'Suscripción',
        logout: 'Cerrar sesión',
        login: 'Iniciar sesión',
        register: 'Comenzar',
        submit: 'Enviar',
        cancel: 'Cancelar',
        save: 'Guardar',
        next: 'Siguiente',
        back: 'Atrás',
        close: 'Cerrar',
        loading: 'Cargando...',
        search: 'Buscar',
        filter: 'Filtrar',
        delete: 'Eliminar',
        edit: 'Editar',
        view: 'Ver',
        download: 'Descargar',
        share: 'Compartir',
        copy: 'Copiar',
        selectBodyParts: 'Seleccione las partes del cuerpo afectadas',
        describeSymptoms: 'Describa sus síntomas',
        duration: 'Duración',
        severity: 'Gravedad',
        medicalHistory: 'Historial médico',
        additionalInfo: 'Información adicional',
        startAssessment: 'Iniciar evaluación',
        viewResults: 'Ver resultados',
        newAssessment: 'Nueva evaluación',
        lessThan24Hours: 'Menos de 24 horas',
        oneToThreeDays: '1-3 días',
        fourToSevenDays: '4-7 días',
        oneToTwoWeeks: '1-2 semanas',
        moreThanTwoWeeks: 'Más de 2 semanas',
        mild: 'Leve',
        moderate: 'Moderado',
        severe: 'Grave',
        emergency: 'Emergencia',
        urgent: 'Urgente',
        routine: 'Rutina',
        freeTrial: 'Prueba gratuita',
        upgradeNow: 'Actualizar ahora',
        viewPlans: 'Ver planes',
        checksRemaining: 'verificaciones restantes',
        unlimited: 'Ilimitado',
        currentPlan: 'Plan actual',
        chooseYourPlan: 'Elige tu plan',
        pricesShownIn: 'Precios mostrados en',
        completePayment: 'Completar pago',
        choosePaymentMethod: 'Elige tu método de pago',
        payWithCard: 'Pagar con tarjeta',
        securePayment: 'Pago seguro con Stripe',
        processingPayment: 'Procesando pago...',
        pleaseWait: 'Por favor espere. No cierre esta ventana.',
        selected: 'Seleccionado',
        selectPlan: 'Seleccionar',
        mostPopular: 'Más popular',
        payPerUse: 'Pago por uso',
        basicMonthly: 'Básico mensual',
        premiumMonthly: 'Premium mensual',
        perCheck: 'por verificación',
        perMonth: '/mes',
        payOnlyWhenNeeded: 'Paga solo cuando lo necesites',
        unlimitedForIndividuals: 'Verificaciones ilimitadas',
        fullAccessPremium: 'Acceso completo + premium',
        singleSymptomCheck: 'Verificación única de síntomas',
        aiPoweredAssessment: 'Evaluación con IA',
        shareWithDoctor: 'Compartir con médico',
        pdfExport: 'Exportar PDF',
        medicalHistoryTracking: 'Seguimiento de historial',
        photoUploadAnalysis: 'Análisis de fotos',
        everythingInBasic: 'Todo del Básico',
        bookOnlineConsultations: 'Consultas online*',
        requestPrescriptions: 'Solicitar recetas*',
        specialtyReferrals: 'Referencias a especialistas*',
        prioritySupport: 'Soporte prioritario',
        additionalFeesApply: '* Cargos adicionales',
        youHaveUnlimitedChecks: 'Tienes verificaciones ilimitadas',
        yourFreeTrialEnded: 'Prueba terminada. Elige un plan.',
        language: 'Idioma',
        selectLanguage: 'Seleccionar idioma',
        theme: 'Tema',
        darkMode: 'Modo oscuro',
        lightMode: 'Modo claro',
        gpDetails: 'Datos del médico',
        nextOfKin: 'Familiar cercano',
        welcomeBack: 'Bienvenido de nuevo',
        trialExhausted: 'Prueba gratuita agotada',
        upgradeToContnue: 'Actualice para continuar',
        noResults: 'No se encontraron resultados',
        errorOccurred: 'Ocurrió un error',
        savedSuccessfully: 'Guardado con éxito',
        shareApp: 'Compartir aplicación',
        installApp: 'Instalar aplicación',
        heroTitle: 'Evaluación de salud con IA',
        heroSubtitle: 'Obtenga información de salud personalizada al instante',
        getStartedFree: 'Comenzar gratis',
        learnMore: 'Más información',
        whyChooseUs: 'Por qué MediGuide',
        howItWorks: 'Cómo funciona',
        features: 'Características',
        aiPowered: 'Análisis con IA',
        aiPoweredDesc: 'La IA analiza sus síntomas para información precisa',
        available247: 'Disponible 24/7',
        available247Desc: 'Obtenga orientación de salud en cualquier momento',
        securePrivate: 'Seguro y privado',
        securePrivateDesc: 'Sus datos de salud están cifrados y protegidos',
        instantResults: 'Resultados instantáneos',
        instantResultsDesc: 'Obtenga recomendaciones en segundos',
        recentAssessments: 'Evaluaciones recientes',
        quickActions: 'Acciones rápidas',
        healthOverview: 'Resumen de salud',
        totalAssessments: 'Total de evaluaciones',
        viewAll: 'Ver todo',
        noAssessments: 'Sin evaluaciones',
        startFirstAssessment: 'Comience su primera evaluación',
        email: 'Correo electrónico',
        password: 'Contraseña',
        confirmPassword: 'Confirmar contraseña',
        forgotPassword: '¿Olvidó su contraseña?',
        rememberMe: 'Recordarme',
        dontHaveAccount: '¿No tiene cuenta?',
        alreadyHaveAccount: '¿Ya tiene cuenta?',
        signUp: 'Registrarse',
        signIn: 'Iniciar sesión',
        orContinueWith: 'O continuar con',
        continueWithGoogle: 'Continuar con Google',
        createAccount: 'Crear cuenta',
        welcomeTo: 'Bienvenido a',
        profile: 'Perfil',
        account: 'Cuenta',
        ownerPanel: 'Panel del propietario',
        name: 'Nombre',
        phone: 'Teléfono',
        address: 'Dirección',
        dateOfBirth: 'Fecha de nacimiento',
        gender: 'Género',
        male: 'Masculino',
        female: 'Femenino',
        other: 'Otro',
        categories: 'Categorías',
        articles: 'Artículos',
        searchArticles: 'Buscar artículos...',
        readMore: 'Leer más',
        possibleConditions: 'Condiciones posibles',
        recommendations: 'Recomendaciones',
        immediateAction: 'Acción inmediata',
        whenToSeekCare: 'Cuándo buscar atención',
        selfCare: 'Autocuidado',
        firstAidTips: 'Consejos de primeros auxilios',
        investigations: 'Investigaciones',
        treatmentOptions: 'Opciones de tratamiento',
        expectedOutcome: 'Resultado esperado',
        disclaimer: 'Aviso',
        disclaimerText: 'Esta evaluación es solo para fines informativos y no reemplaza el consejo médico profesional.',
        exportPDF: 'Exportar PDF',
        shareResults: 'Compartir resultados',
        getBestExperience: 'Obtén la mejor experiencia',
        worksOffline: 'Funciona sin conexión • Acceso rápido • Gratis para siempre',
        joinAsProvider: 'Únete como proveedor de salud',
        quickResults: 'Resultados rápidos',
        underSeconds: 'Menos de 30 segundos',
        backToDashboard: 'Volver al panel',
        backToLibrary: 'Volver a la biblioteca',
        profileInformation: 'Información del perfil',
        updatePersonalDetails: 'Actualice sus datos personales',
        changePhoto: 'Cambiar foto',
        jpgPngGif: 'JPG, PNG o GIF. Máx 5MB',
        fullName: 'Nombre completo',
        phoneNumber: 'Número de teléfono',
        gpDoctorDetails: 'Detalles del médico',
        primaryCarePhysician: 'Información de su médico de cabecera',
        doctorName: 'Nombre del médico',
        practiceAddress: 'Dirección del consultorio',
        emergencyContactInfo: 'Información de contacto de emergencia',
        relationship: 'Relación',
        saveChanges: 'Guardar cambios',
        manageProfile: 'Gestione su perfil y configuración',
        assessmentHistory: 'Historial de evaluaciones',
        viewAndManage: 'Ver y gestionar evaluaciones anteriores',
        allAssessments: 'Todas las evaluaciones',
        newCheck: 'Nueva verificación',
        noAssessmentsYet: 'Aún no hay evaluaciones',
        startFirstSymptomCheck: 'Comience su primera verificación de síntomas',
        today: 'Hoy',
        yesterday: 'Ayer',
        daysAgo: 'días atrás',
        deleteAssessment: 'Eliminar evaluación',
        areYouSureDelete: '¿Está seguro de que desea eliminar esta evaluación? Esta acción no se puede deshacer.',
        yourProfile: 'Su perfil',
        managePersonalInfo: 'Gestione su información personal',
        personal: 'Personal',
        yourHealthAssessment: 'Su evaluación de salud',
        imageAnalyzed: 'Imagen analizada',
        downloadPDF: 'Descargar PDF',
        shareWithDoctor: 'Compartir con el médico',
        generating: 'Generando...',
        callEmergencyServices: 'Llamar a servicios de emergencia',
        reportedSymptoms: 'Síntomas reportados',
        bodyParts: 'Partes del cuerpo',
        loadingDiagnosis: 'Cargando diagnóstico...',
        errorLoadingDiagnosis: 'Error al cargar el diagnóstico',
        returnToDashboard: 'Volver al panel',
        trackHealthPatterns: 'Rastree sus patrones de salud y configure recordatorios',
        addEntry: 'Agregar entrada',
        setReminder: 'Configurar recordatorio',
        patientInfoLeaflets: 'Folletos informativos para pacientes y recursos de salud',
        searchConditions: 'Buscar condiciones, procedimientos...',
        conditions: 'Condiciones',
        procedures: 'Procedimientos',
        resources: 'Recursos',
        overview: 'Resumen',
        causesRiskFactors: 'Causas y factores de riesgo',
        prevention: 'Prevención',
        whenToSeekMedicalHelp: 'Cuándo buscar ayuda médica',
        preparation: 'Preparación',
        theProcedure: 'El procedimiento',
        aftercare: 'Cuidado posterior',
        results: 'Resultados',
        forGeneralGuidance: 'Esta información es solo orientativa. Consulte siempre a su médico para recibir asesoramiento médico personalizado.',
        trackHealthAssessments: 'Rastree sus evaluaciones de salud y obtenga información impulsada por IA.',
        newSymptomCheck: 'Nueva verificación de síntomas',
        getAiPoweredAssessment: 'Obtenga una evaluación de salud impulsada por IA',
        totalChecks: 'Total de verificaciones',
        latestSymptomChecks: 'Sus últimas verificaciones de síntomas',
        startYourFirstCheck: 'Comience su primera verificación',
        languageSettings: 'Configuración de idioma',
        selectPreferredLanguage: 'Seleccione su idioma preferido para la interfaz',
        currentLanguage: 'Idioma actual',
        someMedicalContent: 'Algunos contenidos médicos pueden aparecer en inglés para mayor precisión.',
    },
    
    zh: {
        dashboard: '控制面板',
        checkSymptoms: '检查症状',
        history: '历史',
        healthLibrary: '健康图书馆',
        healthDiary: '健康日记',
        consultations: '咨询',
        referrals: '转介',
        prescriptions: '处方',
        findCare: '寻找护理',
        settings: '设置',
        subscription: '订阅',
        logout: '登出',
        login: '登录',
        register: '开始',
        submit: '提交',
        cancel: '取消',
        save: '保存',
        next: '下一步',
        back: '返回',
        close: '关闭',
        loading: '加载中...',
        search: '搜索',
        filter: '筛选',
        delete: '删除',
        edit: '编辑',
        view: '查看',
        download: '下载',
        share: '分享',
        copy: '复制',
        selectBodyParts: '选择受影响的身体部位',
        describeSymptoms: '描述您的症状',
        duration: '持续时间',
        severity: '严重程度',
        medicalHistory: '病史',
        additionalInfo: '其他信息',
        startAssessment: '开始评估',
        viewResults: '查看结果',
        newAssessment: '新评估',
        lessThan24Hours: '少于24小时',
        oneToThreeDays: '1-3天',
        fourToSevenDays: '4-7天',
        oneToTwoWeeks: '1-2周',
        moreThanTwoWeeks: '超过2周',
        mild: '轻度',
        moderate: '中度',
        severe: '重度',
        emergency: '紧急',
        urgent: '急迫',
        routine: '常规',
        freeTrial: '免费试用',
        upgradeNow: '立即升级',
        viewPlans: '查看方案',
        checksRemaining: '剩余检查次数',
        unlimited: '无限',
        currentPlan: '当前方案',
        chooseYourPlan: '选择您的方案',
        pricesShownIn: '价格显示为',
        completePayment: '完成支付',
        choosePaymentMethod: '选择支付方式',
        payWithCard: '银行卡支付',
        securePayment: '通过Stripe安全支付',
        processingPayment: '正在处理支付...',
        pleaseWait: '请稍候。请勿关闭此窗口。',
        selected: '已选择',
        selectPlan: '选择',
        mostPopular: '最受欢迎',
        payPerUse: '按次付费',
        basicMonthly: '基础月度',
        premiumMonthly: '高级月度',
        perCheck: '每次检查',
        perMonth: '/月',
        payOnlyWhenNeeded: '按需付费',
        unlimitedForIndividuals: '无限检查',
        fullAccessPremium: '完全访问 + 高级功能',
        singleSymptomCheck: '单次症状检查',
        aiPoweredAssessment: 'AI评估',
        shareWithDoctor: '与医生分享',
        pdfExport: 'PDF导出',
        medicalHistoryTracking: '病史追踪',
        photoUploadAnalysis: '照片分析',
        everythingInBasic: '包含基础版所有功能',
        bookOnlineConsultations: '在线咨询*',
        requestPrescriptions: '处方申请*',
        specialtyReferrals: '专科转诊*',
        prioritySupport: '优先支持',
        additionalFeesApply: '* 额外收费',
        youHaveUnlimitedChecks: '您有无限检查次数',
        yourFreeTrialEnded: '试用已结束。请选择方案。',
        language: '语言',
        selectLanguage: '选择语言',
        theme: '主题',
        darkMode: '深色模式',
        lightMode: '浅色模式',
        gpDetails: '医生信息',
        nextOfKin: '紧急联系人',
        welcomeBack: '欢迎回来',
        trialExhausted: '免费试用已用尽',
        upgradeToContnue: '升级以继续',
        noResults: '未找到结果',
        errorOccurred: '发生错误',
        savedSuccessfully: '保存成功',
        shareApp: '分享应用',
        installApp: '安装应用',
        heroTitle: 'AI健康评估',
        heroSubtitle: '获取即时个性化健康建议',
        getStartedFree: '免费开始',
        learnMore: '了解更多',
        whyChooseUs: '为什么选择MediGuide',
        howItWorks: '如何运作',
        features: '功能',
        aiPowered: 'AI驱动分析',
        aiPoweredDesc: 'AI分析您的症状以获得准确见解',
        available247: '全天候可用',
        available247Desc: '随时获取健康指导',
        securePrivate: '安全私密',
        securePrivateDesc: '您的健康数据已加密并受保护',
        instantResults: '即时结果',
        instantResultsDesc: '几秒钟内获得建议',
        recentAssessments: '最近的评估',
        quickActions: '快速操作',
        healthOverview: '健康概览',
        totalAssessments: '总评估数',
        viewAll: '查看全部',
        noAssessments: '暂无评估',
        startFirstAssessment: '开始您的第一次评估',
        email: '电子邮件',
        password: '密码',
        confirmPassword: '确认密码',
        forgotPassword: '忘记密码?',
        rememberMe: '记住我',
        dontHaveAccount: '没有账户?',
        alreadyHaveAccount: '已有账户?',
        signUp: '注册',
        signIn: '登录',
        orContinueWith: '或继续使用',
        continueWithGoogle: '使用Google继续',
        createAccount: '创建账户',
        welcomeTo: '欢迎来到',
        profile: '个人资料',
        account: '账户',
        ownerPanel: '所有者面板',
        name: '姓名',
        phone: '电话',
        address: '地址',
        dateOfBirth: '出生日期',
        gender: '性别',
        male: '男',
        female: '女',
        other: '其他',
        categories: '分类',
        articles: '文章',
        searchArticles: '搜索文章...',
        readMore: '阅读更多',
        possibleConditions: '可能的情况',
        recommendations: '建议',
        immediateAction: '立即行动',
        whenToSeekCare: '何时就医',
        selfCare: '自我护理',
        firstAidTips: '急救提示',
        investigations: '检查',
        treatmentOptions: '治疗选项',
        expectedOutcome: '预期结果',
        disclaimer: '免责声明',
        disclaimerText: '此评估仅供参考，不能替代专业医疗建议。',
        exportPDF: '导出PDF',
        shareResults: '分享结果',
        getBestExperience: '获得最佳体验',
        worksOffline: '离线工作 • 快速访问 • 永久免费',
        joinAsProvider: '以医疗服务提供者身份加入',
        quickResults: '快速结果',
        underSeconds: '30秒内',
        backToDashboard: '返回控制面板',
        backToLibrary: '返回图书馆',
        profileInformation: '个人资料信息',
        updatePersonalDetails: '更新您的个人资料',
        changePhoto: '更换照片',
        jpgPngGif: 'JPG、PNG或GIF，最大5MB',
        fullName: '全名',
        phoneNumber: '电话号码',
        gpDoctorDetails: '医生详情',
        primaryCarePhysician: '您的家庭医生信息',
        doctorName: '医生姓名',
        practiceAddress: '诊所地址',
        emergencyContactInfo: '紧急联系人信息',
        relationship: '关系',
        saveChanges: '保存更改',
        manageProfile: '管理您的个人资料和设置',
        assessmentHistory: '评估历史',
        viewAndManage: '查看和管理过去的评估',
        allAssessments: '所有评估',
        newCheck: '新检查',
        noAssessmentsYet: '暂无评估',
        startFirstSymptomCheck: '开始您的第一次症状检查',
        today: '今天',
        yesterday: '昨天',
        daysAgo: '天前',
        deleteAssessment: '删除评估',
        areYouSureDelete: '您确定要删除此评估吗？此操作无法撤消。',
        yourProfile: '您的个人资料',
        managePersonalInfo: '管理您的个人信息',
        personal: '个人',
        yourHealthAssessment: '您的健康评估',
        imageAnalyzed: '已分析图像',
        downloadPDF: '下载PDF',
        shareWithDoctor: '与医生分享',
        generating: '正在生成...',
        callEmergencyServices: '拨打急救电话',
        reportedSymptoms: '报告的症状',
        bodyParts: '身体部位',
        loadingDiagnosis: '正在加载诊断...',
        errorLoadingDiagnosis: '加载诊断时出错',
        returnToDashboard: '返回控制面板',
        trackHealthPatterns: '跟踪您的健康模式并设置提醒',
        addEntry: '添加条目',
        setReminder: '设置提醒',
        patientInfoLeaflets: '患者信息单和健康资源',
        searchConditions: '搜索疾病、程序...',
        conditions: '疾病',
        procedures: '程序',
        resources: '资源',
        overview: '概述',
        causesRiskFactors: '原因和风险因素',
        prevention: '预防',
        whenToSeekMedicalHelp: '何时就医',
        preparation: '准备',
        theProcedure: '手术过程',
        aftercare: '术后护理',
        results: '结果',
        forGeneralGuidance: '此信息仅供一般指导。请始终咨询您的医生以获取个性化的医疗建议。',
        trackHealthAssessments: '跟踪您的健康评估并获取AI驱动的洞察。',
        newSymptomCheck: '新症状检查',
        getAiPoweredAssessment: '获取AI驱动的健康评估',
        totalChecks: '总检查次数',
        latestSymptomChecks: '您最近的症状检查',
        startYourFirstCheck: '开始您的第一次检查',
        languageSettings: '语言设置',
        selectPreferredLanguage: '选择您首选的界面语言',
        currentLanguage: '当前语言',
        someMedicalContent: '为保证准确性，部分医疗内容可能仍以英语显示。',
    },
    
    hi: {
        dashboard: 'डैशबोर्ड',
        checkSymptoms: 'लक्षण जांचें',
        history: 'इतिहास',
        healthLibrary: 'स्वास्थ्य पुस्तकालय',
        healthDiary: 'स्वास्थ्य डायरी',
        consultations: 'परामर्श',
        referrals: 'रेफरल',
        prescriptions: 'नुस्खे',
        findCare: 'देखभाल खोजें',
        settings: 'सेटिंग्स',
        subscription: 'सदस्यता',
        logout: 'लॉग आउट',
        login: 'लॉग इन',
        register: 'शुरू करें',
        submit: 'जमा करें',
        cancel: 'रद्द करें',
        save: 'सहेजें',
        next: 'अगला',
        back: 'पीछे',
        close: 'बंद करें',
        loading: 'लोड हो रहा है...',
        search: 'खोजें',
        filter: 'फ़िल्टर',
        delete: 'हटाएं',
        edit: 'संपादित करें',
        view: 'देखें',
        download: 'डाउनलोड',
        share: 'साझा करें',
        copy: 'कॉपी करें',
        selectBodyParts: 'प्रभावित शरीर के अंग चुनें',
        describeSymptoms: 'अपने लक्षण बताएं',
        duration: 'अवधि',
        severity: 'गंभीरता',
        medicalHistory: 'चिकित्सा इतिहास',
        additionalInfo: 'अतिरिक्त जानकारी',
        startAssessment: 'मूल्यांकन शुरू करें',
        viewResults: 'परिणाम देखें',
        newAssessment: 'नया मूल्यांकन',
        lessThan24Hours: '24 घंटे से कम',
        oneToThreeDays: '1-3 दिन',
        fourToSevenDays: '4-7 दिन',
        oneToTwoWeeks: '1-2 सप्ताह',
        moreThanTwoWeeks: '2 सप्ताह से अधिक',
        mild: 'हल्का',
        moderate: 'मध्यम',
        severe: 'गंभीर',
        emergency: 'आपातकालीन',
        urgent: 'तत्काल',
        routine: 'नियमित',
        freeTrial: 'मुफ्त परीक्षण',
        upgradeNow: 'अभी अपग्रेड करें',
        viewPlans: 'योजनाएं देखें',
        checksRemaining: 'जांच शेष',
        unlimited: 'असीमित',
        currentPlan: 'वर्तमान योजना',
        chooseYourPlan: 'अपनी योजना चुनें',
        pricesShownIn: 'कीमतें दिखाई गई',
        completePayment: 'भुगतान पूरा करें',
        choosePaymentMethod: 'भुगतान विधि चुनें',
        payWithCard: 'कार्ड से भुगतान करें',
        securePayment: 'Stripe द्वारा सुरक्षित भुगतान',
        processingPayment: 'भुगतान प्रोसेस हो रहा है...',
        pleaseWait: 'कृपया प्रतीक्षा करें। विंडो बंद न करें।',
        selected: 'चयनित',
        selectPlan: 'चुनें',
        mostPopular: 'सबसे लोकप्रिय',
        payPerUse: 'उपयोग के अनुसार भुगतान',
        basicMonthly: 'बेसिक मासिक',
        premiumMonthly: 'प्रीमियम मासिक',
        perCheck: 'प्रति जांच',
        perMonth: '/माह',
        payOnlyWhenNeeded: 'जरूरत पड़ने पर ही भुगतान करें',
        unlimitedForIndividuals: 'असीमित जांच',
        fullAccessPremium: 'पूर्ण पहुंच + प्रीमियम',
        singleSymptomCheck: 'एकल लक्षण जांच',
        aiPoweredAssessment: 'AI मूल्यांकन',
        shareWithDoctor: 'डॉक्टर के साथ साझा करें',
        pdfExport: 'PDF निर्यात',
        medicalHistoryTracking: 'चिकित्सा इतिहास ट्रैकिंग',
        photoUploadAnalysis: 'फोटो विश्लेषण',
        everythingInBasic: 'बेसिक में सब कुछ',
        bookOnlineConsultations: 'ऑनलाइन परामर्श*',
        requestPrescriptions: 'प्रिस्क्रिप्शन अनुरोध*',
        specialtyReferrals: 'विशेषज्ञ रेफरल*',
        prioritySupport: 'प्राथमिकता सहायता',
        additionalFeesApply: '* अतिरिक्त शुल्क',
        youHaveUnlimitedChecks: 'आपके पास असीमित जांच है',
        yourFreeTrialEnded: 'परीक्षण समाप्त। योजना चुनें।',
        language: 'भाषा',
        selectLanguage: 'भाषा चुनें',
        theme: 'थीम',
        darkMode: 'डार्क मोड',
        lightMode: 'लाइट मोड',
        gpDetails: 'डॉक्टर विवरण',
        nextOfKin: 'निकटतम संबंधी',
        welcomeBack: 'वापस स्वागत है',
        trialExhausted: 'मुफ्त परीक्षण समाप्त',
        upgradeToContnue: 'जारी रखने के लिए अपग्रेड करें',
        noResults: 'कोई परिणाम नहीं मिला',
        errorOccurred: 'एक त्रुटि हुई',
        savedSuccessfully: 'सफलतापूर्वक सहेजा गया',
        shareApp: 'ऐप शेयर करें',
        installApp: 'ऐप इंस्टॉल करें',
        heroTitle: 'AI स्वास्थ्य मूल्यांकन',
        heroSubtitle: 'तत्काल व्यक्तिगत स्वास्थ्य जानकारी प्राप्त करें',
        getStartedFree: 'मुफ्त शुरू करें',
        learnMore: 'और जानें',
        whyChooseUs: 'MediGuide क्यों चुनें',
        howItWorks: 'यह कैसे काम करता है',
        features: 'सुविधाएं',
        aiPowered: 'AI-संचालित विश्लेषण',
        aiPoweredDesc: 'AI आपके लक्षणों का विश्लेषण करता है',
        available247: '24/7 उपलब्ध',
        available247Desc: 'कभी भी स्वास्थ्य मार्गदर्शन प्राप्त करें',
        securePrivate: 'सुरक्षित और निजी',
        securePrivateDesc: 'आपका स्वास्थ्य डेटा एन्क्रिप्टेड और सुरक्षित है',
        instantResults: 'तत्काल परिणाम',
        instantResultsDesc: 'सेकंड में सिफारिशें प्राप्त करें',
        recentAssessments: 'हाल के मूल्यांकन',
        quickActions: 'त्वरित कार्य',
        healthOverview: 'स्वास्थ्य अवलोकन',
        totalAssessments: 'कुल मूल्यांकन',
        viewAll: 'सभी देखें',
        noAssessments: 'कोई मूल्यांकन नहीं',
        startFirstAssessment: 'अपना पहला मूल्यांकन शुरू करें',
        email: 'ईमेल',
        password: 'पासवर्ड',
        confirmPassword: 'पासवर्ड की पुष्टि करें',
        forgotPassword: 'पासवर्ड भूल गए?',
        rememberMe: 'मुझे याद रखें',
        dontHaveAccount: 'खाता नहीं है?',
        alreadyHaveAccount: 'पहले से खाता है?',
        signUp: 'साइन अप',
        signIn: 'साइन इन',
        orContinueWith: 'या इसके साथ जारी रखें',
        continueWithGoogle: 'Google के साथ जारी रखें',
        createAccount: 'खाता बनाएं',
        welcomeTo: 'स्वागत है',
        profile: 'प्रोफ़ाइल',
        account: 'खाता',
        ownerPanel: 'मालिक पैनल',
        name: 'नाम',
        phone: 'फोन',
        address: 'पता',
        dateOfBirth: 'जन्म तिथि',
        gender: 'लिंग',
        male: 'पुरुष',
        female: 'महिला',
        other: 'अन्य',
        categories: 'श्रेणियां',
        articles: 'लेख',
        searchArticles: 'लेख खोजें...',
        readMore: 'और पढ़ें',
        possibleConditions: 'संभावित स्थितियां',
        recommendations: 'सिफारिशें',
        immediateAction: 'तत्काल कार्रवाई',
        whenToSeekCare: 'कब देखभाल लें',
        selfCare: 'स्व-देखभाल',
        firstAidTips: 'प्राथमिक चिकित्सा सुझाव',
        investigations: 'जांच',
        treatmentOptions: 'उपचार विकल्प',
        expectedOutcome: 'अपेक्षित परिणाम',
        disclaimer: 'अस्वीकरण',
        disclaimerText: 'यह मूल्यांकन केवल सूचनात्मक उद्देश्यों के लिए है और पेशेवर चिकित्सा सलाह को प्रतिस्थापित नहीं करता।',
        exportPDF: 'PDF निर्यात करें',
        shareResults: 'परिणाम साझा करें',
        getBestExperience: 'सर्वोत्तम अनुभव प्राप्त करें',
        worksOffline: 'ऑफ़लाइन काम करता है • त्वरित पहुंच • हमेशा मुफ्त',
        joinAsProvider: 'स्वास्थ्य सेवा प्रदाता के रूप में शामिल हों',
        quickResults: 'त्वरित परिणाम',
        underSeconds: '30 सेकंड से कम',
        backToDashboard: 'डैशबोर्ड पर वापस',
        backToLibrary: 'पुस्तकालय पर वापस',
        profileInformation: 'प्रोफ़ाइल जानकारी',
        updatePersonalDetails: 'अपनी व्यक्तिगत जानकारी अपडेट करें',
        changePhoto: 'फोटो बदलें',
        jpgPngGif: 'JPG, PNG या GIF. अधिकतम 5MB',
        fullName: 'पूरा नाम',
        phoneNumber: 'फोन नंबर',
        gpDoctorDetails: 'डॉक्टर का विवरण',
        primaryCarePhysician: 'आपके प्राथमिक चिकित्सक की जानकारी',
        doctorName: 'डॉक्टर का नाम',
        practiceAddress: 'क्लिनिक का पता',
        emergencyContactInfo: 'आपातकालीन संपर्क जानकारी',
        relationship: 'संबंध',
        saveChanges: 'परिवर्तन सहेजें',
        manageProfile: 'अपनी प्रोफ़ाइल और सेटिंग्स प्रबंधित करें',
        assessmentHistory: 'मूल्यांकन इतिहास',
        viewAndManage: 'पिछले मूल्यांकन देखें और प्रबंधित करें',
        allAssessments: 'सभी मूल्यांकन',
        newCheck: 'नई जांच',
        noAssessmentsYet: 'अभी तक कोई मूल्यांकन नहीं',
        startFirstSymptomCheck: 'अपनी पहली लक्षण जांच शुरू करें',
        today: 'आज',
        yesterday: 'कल',
        daysAgo: 'दिन पहले',
        deleteAssessment: 'मूल्यांकन हटाएं',
        areYouSureDelete: 'क्या आप वाकई इस मूल्यांकन को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।',
        yourProfile: 'आपकी प्रोफ़ाइल',
        managePersonalInfo: 'अपनी व्यक्तिगत जानकारी प्रबंधित करें',
        personal: 'व्यक्तिगत',
        yourHealthAssessment: 'आपका स्वास्थ्य मूल्यांकन',
        imageAnalyzed: 'छवि का विश्लेषण किया गया',
        downloadPDF: 'PDF डाउनलोड करें',
        shareWithDoctor: 'डॉक्टर के साथ साझा करें',
        generating: 'उत्पन्न हो रहा है...',
        callEmergencyServices: 'आपातकालीन सेवाओं को कॉल करें',
        reportedSymptoms: 'रिपोर्ट किए गए लक्षण',
        bodyParts: 'शरीर के अंग',
        loadingDiagnosis: 'निदान लोड हो रहा है...',
        errorLoadingDiagnosis: 'निदान लोड करने में त्रुटि',
        returnToDashboard: 'डैशबोर्ड पर वापस',
        trackHealthPatterns: 'अपने स्वास्थ्य पैटर्न को ट्रैक करें और अनुस्मारक सेट करें',
        addEntry: 'प्रविष्टि जोड़ें',
        setReminder: 'अनुस्मारक सेट करें',
        patientInfoLeaflets: 'रोगी सूचना पत्रक और स्वास्थ्य संसाधन',
        searchConditions: 'स्थितियां, प्रक्रियाएं खोजें...',
        conditions: 'स्थितियां',
        procedures: 'प्रक्रियाएं',
        resources: 'संसाधन',
        overview: 'अवलोकन',
        causesRiskFactors: 'कारण और जोखिम कारक',
        prevention: 'रोकथाम',
        whenToSeekMedicalHelp: 'चिकित्सा सहायता कब लें',
        preparation: 'तैयारी',
        theProcedure: 'प्रक्रिया',
        aftercare: 'बाद की देखभाल',
        results: 'परिणाम',
        forGeneralGuidance: 'यह जानकारी केवल सामान्य मार्गदर्शन के लिए है। व्यक्तिगत चिकित्सा सलाह के लिए हमेशा अपने डॉक्टर से परामर्श करें।',
        trackHealthAssessments: 'अपने स्वास्थ्य मूल्यांकन को ट्रैक करें और AI-संचालित अंतर्दृष्टि प्राप्त करें।',
        newSymptomCheck: 'नई लक्षण जांच',
        getAiPoweredAssessment: 'AI-संचालित स्वास्थ्य मूल्यांकन प्राप्त करें',
        totalChecks: 'कुल जांचें',
        latestSymptomChecks: 'आपकी नवीनतम लक्षण जांचें',
        startYourFirstCheck: 'अपनी पहली जांच शुरू करें',
        languageSettings: 'भाषा सेटिंग्स',
        selectPreferredLanguage: 'इंटरफ़ेस के लिए अपनी पसंदीदा भाषा चुनें',
        currentLanguage: 'वर्तमान भाषा',
        someMedicalContent: 'सटीकता के लिए कुछ चिकित्सा सामग्री अभी भी अंग्रेजी में दिखाई दे सकती है।',
    },
    
    sw: {
        dashboard: 'Dashibodi',
        checkSymptoms: 'Angalia dalili',
        history: 'Historia',
        healthLibrary: 'Maktaba ya afya',
        healthDiary: 'Diari ya afya',
        consultations: 'Mashauriano',
        referrals: 'Rufaa',
        prescriptions: 'Maagizo ya dawa',
        findCare: 'Tafuta huduma',
        settings: 'Mipangilio',
        subscription: 'Usajili',
        logout: 'Ondoka',
        login: 'Ingia',
        register: 'Anza',
        submit: 'Wasilisha',
        cancel: 'Ghairi',
        save: 'Hifadhi',
        next: 'Ifuatayo',
        back: 'Rudi',
        close: 'Funga',
        loading: 'Inapakia...',
        search: 'Tafuta',
        filter: 'Chuja',
        delete: 'Futa',
        edit: 'Hariri',
        view: 'Tazama',
        download: 'Pakua',
        share: 'Shiriki',
        copy: 'Nakili',
        selectBodyParts: 'Chagua sehemu za mwili zilizoathiriwa',
        describeSymptoms: 'Eleza dalili zako',
        duration: 'Muda',
        severity: 'Ukali',
        medicalHistory: 'Historia ya matibabu',
        additionalInfo: 'Maelezo zaidi',
        startAssessment: 'Anza tathmini',
        viewResults: 'Tazama matokeo',
        newAssessment: 'Tathmini mpya',
        lessThan24Hours: 'Chini ya saa 24',
        oneToThreeDays: 'Siku 1-3',
        fourToSevenDays: 'Siku 4-7',
        oneToTwoWeeks: 'Wiki 1-2',
        moreThanTwoWeeks: 'Zaidi ya wiki 2',
        mild: 'Nyepesi',
        moderate: 'Wastani',
        severe: 'Kali',
        emergency: 'Dharura',
        urgent: 'Haraka',
        routine: 'Kawaida',
        freeTrial: 'Jaribio la bure',
        upgradeNow: 'Boresha sasa',
        viewPlans: 'Tazama mipango',
        checksRemaining: 'ukaguzi uliobaki',
        unlimited: 'Bila kikomo',
        currentPlan: 'Mpango wa sasa',
        chooseYourPlan: 'Chagua mpango wako',
        pricesShownIn: 'Bei zimeonyeshwa kwa',
        completePayment: 'Kamilisha malipo',
        choosePaymentMethod: 'Chagua njia ya malipo',
        payWithCard: 'Lipa kwa kadi',
        securePayment: 'Malipo salama kupitia Stripe',
        processingPayment: 'Inachakata malipo...',
        pleaseWait: 'Tafadhali subiri. Usifunge dirisha.',
        selected: 'Imechaguliwa',
        selectPlan: 'Chagua',
        mostPopular: 'Maarufu zaidi',
        payPerUse: 'Lipa kwa matumizi',
        basicMonthly: 'Msingi wa kila mwezi',
        premiumMonthly: 'Premium ya kila mwezi',
        perCheck: 'kwa ukaguzi',
        perMonth: '/mwezi',
        payOnlyWhenNeeded: 'Lipa tu unapohitaji',
        unlimitedForIndividuals: 'Ukaguzi bila kikomo',
        fullAccessPremium: 'Upatikanaji kamili + premium',
        singleSymptomCheck: 'Ukaguzi mmoja wa dalili',
        aiPoweredAssessment: 'Tathmini ya AI',
        shareWithDoctor: 'Shiriki na daktari',
        pdfExport: 'Hamisha PDF',
        medicalHistoryTracking: 'Ufuatiliaji wa historia',
        photoUploadAnalysis: 'Uchambuzi wa picha',
        everythingInBasic: 'Kila kitu katika Msingi',
        bookOnlineConsultations: 'Ushauri mtandaoni*',
        requestPrescriptions: 'Omba dawa*',
        specialtyReferrals: 'Rufaa za wataalamu*',
        prioritySupport: 'Msaada wa kipaumbele',
        additionalFeesApply: '* Ada za ziada',
        youHaveUnlimitedChecks: 'Una ukaguzi bila kikomo',
        yourFreeTrialEnded: 'Jaribio limekwisha. Chagua mpango.',
        language: 'Lugha',
        selectLanguage: 'Chagua lugha',
        theme: 'Mandhari',
        darkMode: 'Hali ya giza',
        lightMode: 'Hali ya mwanga',
        gpDetails: 'Maelezo ya daktari',
        nextOfKin: 'Ndugu wa karibu',
        welcomeBack: 'Karibu tena',
        trialExhausted: 'Jaribio la bure limekwisha',
        upgradeToContnue: 'Boresha ili kuendelea',
        noResults: 'Hakuna matokeo',
        errorOccurred: 'Hitilafu imetokea',
        savedSuccessfully: 'Imehifadhiwa',
        shareApp: 'Shiriki programu',
        installApp: 'Sakinisha programu',
        heroTitle: 'Tathmini ya afya ya AI',
        heroSubtitle: 'Pata maarifa ya afya ya haraka yaliyobinafsishwa',
        getStartedFree: 'Anza bure',
        learnMore: 'Jifunze zaidi',
        whyChooseUs: 'Kwa nini MediGuide',
        howItWorks: 'Inavyofanya kazi',
        features: 'Vipengele',
        aiPowered: 'Uchambuzi wa AI',
        aiPoweredDesc: 'AI inachambua dalili zako kwa ufahamu sahihi',
        available247: 'Inapatikana 24/7',
        available247Desc: 'Pata mwongozo wa afya wakati wowote',
        securePrivate: 'Salama na faragha',
        securePrivateDesc: 'Data yako ya afya imesimbwa na kulindwa',
        instantResults: 'Matokeo ya papo hapo',
        instantResultsDesc: 'Pata mapendekezo kwa sekunde',
        recentAssessments: 'Tathmini za hivi karibuni',
        quickActions: 'Vitendo vya haraka',
        healthOverview: 'Muhtasari wa afya',
        totalAssessments: 'Jumla ya tathmini',
        viewAll: 'Tazama zote',
        noAssessments: 'Hakuna tathmini',
        startFirstAssessment: 'Anza tathmini yako ya kwanza',
        email: 'Barua pepe',
        password: 'Nenosiri',
        confirmPassword: 'Thibitisha nenosiri',
        forgotPassword: 'Umesahau nenosiri?',
        rememberMe: 'Nikumbuke',
        dontHaveAccount: 'Huna akaunti?',
        alreadyHaveAccount: 'Una akaunti tayari?',
        signUp: 'Jisajili',
        signIn: 'Ingia',
        orContinueWith: 'Au endelea na',
        continueWithGoogle: 'Endelea na Google',
        createAccount: 'Fungua akaunti',
        welcomeTo: 'Karibu',
        profile: 'Wasifu',
        account: 'Akaunti',
        ownerPanel: 'Paneli ya mmiliki',
        name: 'Jina',
        phone: 'Simu',
        address: 'Anwani',
        dateOfBirth: 'Tarehe ya kuzaliwa',
        gender: 'Jinsia',
        male: 'Mwanaume',
        female: 'Mwanamke',
        other: 'Nyingine',
        categories: 'Kategoria',
        articles: 'Makala',
        searchArticles: 'Tafuta makala...',
        readMore: 'Soma zaidi',
        possibleConditions: 'Hali zinazowezekana',
        recommendations: 'Mapendekezo',
        immediateAction: 'Hatua ya haraka',
        whenToSeekCare: 'Wakati wa kutafuta huduma',
        selfCare: 'Kujitunza',
        firstAidTips: 'Vidokezo vya huduma ya kwanza',
        investigations: 'Uchunguzi',
        treatmentOptions: 'Chaguo za matibabu',
        expectedOutcome: 'Matokeo yanayotarajiwa',
        disclaimer: 'Onyo',
        disclaimerText: 'Tathmini hii ni kwa madhumuni ya habari tu na haichukui nafasi ya ushauri wa kitaalamu wa matibabu.',
        exportPDF: 'Hamisha PDF',
        shareResults: 'Shiriki matokeo',
        getBestExperience: 'Pata uzoefu bora',
        worksOffline: 'Inafanya kazi nje ya mtandao • Ufikiaji wa haraka • Bure milele',
        joinAsProvider: 'Jiunge kama mtoa huduma za afya',
        quickResults: 'Matokeo ya haraka',
        underSeconds: 'Chini ya sekunde 30',
        backToDashboard: 'Rudi kwenye dashibodi',
        backToLibrary: 'Rudi kwenye maktaba',
        profileInformation: 'Taarifa za wasifu',
        updatePersonalDetails: 'Sasisha maelezo yako binafsi',
        changePhoto: 'Badilisha picha',
        jpgPngGif: 'JPG, PNG au GIF. Max 5MB',
        fullName: 'Jina kamili',
        phoneNumber: 'Nambari ya simu',
        gpDoctorDetails: 'Maelezo ya daktari',
        primaryCarePhysician: 'Taarifa za daktari wako wa familia',
        doctorName: 'Jina la daktari',
        practiceAddress: 'Anwani ya kliniki',
        emergencyContactInfo: 'Taarifa za mawasiliano ya dharura',
        relationship: 'Uhusiano',
        saveChanges: 'Hifadhi mabadiliko',
        manageProfile: 'Dhibiti wasifu na mipangilio yako',
        assessmentHistory: 'Historia ya tathmini',
        viewAndManage: 'Tazama na udhibiti tathmini zilizopita',
        allAssessments: 'Tathmini zote',
        newCheck: 'Ukaguzi mpya',
        noAssessmentsYet: 'Hakuna tathmini bado',
        startFirstSymptomCheck: 'Anza ukaguzi wako wa kwanza wa dalili',
        today: 'Leo',
        yesterday: 'Jana',
        daysAgo: 'siku zilizopita',
        deleteAssessment: 'Futa tathmini',
        areYouSureDelete: 'Je, una uhakika unataka kufuta tathmini hii? Kitendo hiki hakiwezi kutenduliwa.',
        yourProfile: 'Wasifu wako',
        managePersonalInfo: 'Dhibiti taarifa zako binafsi',
        personal: 'Binafsi',
        yourHealthAssessment: 'Tathmini yako ya afya',
        imageAnalyzed: 'Picha imechambuliwa',
        downloadPDF: 'Pakua PDF',
        shareWithDoctor: 'Shiriki na daktari',
        generating: 'Inaunda...',
        callEmergencyServices: 'Piga simu huduma za dharura',
        reportedSymptoms: 'Dalili zilizoripotiwa',
        bodyParts: 'Sehemu za mwili',
        loadingDiagnosis: 'Inapakia uchunguzi...',
        errorLoadingDiagnosis: 'Hitilafu katika kupakia uchunguzi',
        returnToDashboard: 'Rudi kwenye dashibodi',
        trackHealthPatterns: 'Fuatilia mifumo yako ya afya na weka vikumbusho',
        addEntry: 'Ongeza ingizo',
        setReminder: 'Weka kikumbusho',
        patientInfoLeaflets: 'Vipeperushi vya taarifa za mgonjwa na rasilimali za afya',
        searchConditions: 'Tafuta hali, taratibu...',
        conditions: 'Hali',
        procedures: 'Taratibu',
        resources: 'Rasilimali',
        overview: 'Muhtasari',
        causesRiskFactors: 'Sababu na sababu za hatari',
        prevention: 'Kuzuia',
        whenToSeekMedicalHelp: 'Wakati wa kutafuta msaada wa kimatibabu',
        preparation: 'Maandalizi',
        theProcedure: 'Utaratibu',
        aftercare: 'Huduma baada',
        results: 'Matokeo',
        forGeneralGuidance: 'Taarifa hii ni kwa mwongozo wa jumla tu. Daima wasiliana na daktari wako kwa ushauri wa kimatibabu uliobinafsishwa.',
        trackHealthAssessments: 'Fuatilia tathmini zako za afya na upate maarifa yanayoendeshwa na AI.',
        newSymptomCheck: 'Ukaguzi mpya wa dalili',
        getAiPoweredAssessment: 'Pata tathmini ya afya inayoendeshwa na AI',
        totalChecks: 'Jumla ya ukaguzi',
        latestSymptomChecks: 'Ukaguzi wako wa hivi karibuni wa dalili',
        startYourFirstCheck: 'Anza ukaguzi wako wa kwanza',
        languageSettings: 'Mipangilio ya lugha',
        selectPreferredLanguage: 'Chagua lugha yako unayopendelea kwa kiolesura',
        currentLanguage: 'Lugha ya sasa',
        someMedicalContent: 'Maudhui mengine ya kimatibabu yanaweza bado kuonekana kwa Kiingereza kwa usahihi.',
    },
};
